<template>
    <div class="tab_content">
        <div class="templete">
            <div class="search_box clearfix">
                <div class="search_time search_inputBox">
                    <el-date-picker v-model="start_time" @keyup.enter.native="getList(true)" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="订单开始"></el-date-picker>
                    ~
                    <el-date-picker v-model="end_time" @keyup.enter.native="getList(true)" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="订单结束"></el-date-picker>
                </div>
                <div class="search_time search_inputBox">
                    <el-date-picker v-model="start_over_time" @keyup.enter.native="getList(true)" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="完成开始"></el-date-picker>
                    ~
                    <el-date-picker v-model="end_over_time" @keyup.enter.native="getList(true)" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="完成结束"></el-date-picker>
                </div>
                <el-select class="search_select search_inputBox" @keyup.enter.native="getList(true)" v-model="params.jg_type" multiple collapse-tags placeholder="加工类型" @visible-change="getSelectTranslateList('jg_type')">
                    <el-option v-for="list in selectMapC.jg_type" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" @keyup.enter.native="getList(true)" multiple collapse-tags  v-model="params.status" placeholder="订单状态" @visible-change="getSelectTranslateList('status')">
                    <el-option v-for="list in selectMapC.status" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" @keyup.enter.native="getList(true)" v-model="params.factory_id" placeholder="加工厂" @visible-change="getSelectTranslateList('factory_id')">
                    <el-option v-for="list in selectMapC.factory_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-input class="search_input search_inputBox" @keyup.enter.native="getList(true)" v-model="params.drying_cave" placeholder="烘干窑"></el-input>
                <el-select class="search_select search_inputBox" @keyup.enter.native="getList(true)" v-model="params.in_warehouse_id" placeholder="仓库" @visible-change="getSelectTranslateList('in_warehouse_id')">
                    <el-option v-for="list in selectMapC.in_warehouse_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-if="isShowMore" @keyup.enter.native="getList(true)" v-model="params.transfer_id" placeholder="入库确认人" @visible-change="getSelectTranslateList('transfer_id')">
                    <el-option v-for="list in selectMapC.transfer_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-if="isShowMore" @keyup.enter.native="getList(true)" v-model="params.creator_id" placeholder="制单人" @visible-change="getSelectTranslateList('creator_id')">
                    <el-option v-for="list in selectMapC.creator_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-if="isShowMore" @keyup.enter.native="getList(true)" v-model="params.reviewer_id" placeholder="审核人" @visible-change="getSelectTranslateList('reviewer_id')">
                    <el-option v-for="list in selectMapC.reviewer_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-input class="search_input search_inputBox" @keyup.enter.native="getList(true)" v-model="params.order_sn" placeholder="翻包加工单号"></el-input>
                <!--<el-select class="search_select search_inputBox" @keyup.enter.native="getList(true)" v-model="params.status" placeholder="翻包状态">
                    <el-option :value="1" :label="'已完成'"></el-option>
                    <el-option :value="2" :label="'翻包加工中'"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" @keyup.enter.native="getList(true)" v-model="params.creator_id" placeholder="翻包加工人" @visible-change="getSelectList('translate')">
                    <el-option v-for="list in selectMap.translate" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select> -->
                <el-input class="search_input search_inputBox" v-if="isShowMore" @keyup.enter.native="getList(true)" v-model="params.remark" placeholder="备注"></el-input>
                <div class="searchBtnList clearfix">
                    <div class="reset fcolor" @click="isShowMore=!isShowMore">{{isShowMore?'收起':'更多'}}</div>
                    <div class="reset fcolor" @click="reset">重置</div>
                    <el-button  class="publicBtn" @click="getList(true)">查询</el-button>
                </div>
                <div class="execlInsert execlInsertHasFilter clearfix">
                    <div class="filterBtn" @click="filterDialogVisibleOut=!filterDialogVisibleOut;scene='translate.package.list';isGlobal=false;filter=filter;"></div>
                </div>
            </div>
            <div class="btnList clearfix">
                <el-button class="funcPublicBtn funcPublicBtnChecked" v-if="module.indexOf(',warehouse-combind-edit,')!=-1" @click="dialogVisible=!dialogVisible;isGlobal = true;">新增翻包加工</el-button>
                <el-button class="funcPublicBtn" @click="batchDel" v-if="module.indexOf(',customer-del,')!=-1">删除</el-button>
            </div>
            <div class="tableBox">
                <tabletem :isSetCol="true" scene="translate.package.list"  :isLoading="tableLoading" :tablecol="tableCol" :tabledata="list" @getRow="getRow" @rowClick="rowClick" @getTableEdit="edit" @getTableDelete="del"></tabletem>
            </div>
            <div class="totalCal no_print">
                <div class="totalNumber">合计：</div>
                <div class="totalNumber">{{totalObj.count}}单</div>
                <div class="totalNumber">原料方数: {{totalObj.cube}}m³</div>
                <div class="totalNumber">成品方数: {{totalObj.new_cube}}m³</div>
                <div class="totalNumber">
                    <div class="contractLabel" style="position:relative;">
                        <div class="labelTip">
                            <div class="laCbelTipC" >
                                订单已完成的原料成本金额-成品采购金额
                            </div>
                        </div>
                       加工盈亏:  
                        <span style="color: red;" v-if="totalObj.profit_amount<0"> {{totalObj.profit_amount}}</span>
                        <span v-else> {{totalObj.profit_amount}}</span>
                    </div>
                    
                </div>
            </div>  
            <div class="pageBox">
                <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="params.page" :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
            </div>
        </div>
        <!-- dialog START -->
        <el-dialog v-dialog-drag :visible.sync="dialogVisible" class="eldialog eldialogC  eldialogTransfer eldialogWidth" :modal="false" :title="'新建翻包加工单'" custom-class="full_dialog">
            <div class="dialogSearchBox">
                <el-form :rules="formRules" :model="form_params" ref="saleorderA" class="clearfix dialogFormB dialogForm">
                    <div class="elFormBox">
                        <!-- :disabled="!saleOrderIsEdit" -->
                        <el-form-item  label="订单日期：" prop="tran_date">
                            <el-date-picker  v-model="form_params.tran_date" type="date" size="mini"></el-date-picker>
                        </el-form-item>
                    </div>
                    <div class="elFormBox"> 
                        <el-form-item  label="加工类型：" prop="jg_type">
                            <el-select v-model="form_params.jg_type" @visible-change="getSelectList('translateJgtypeOption',$event)">
                                <el-option v-for="list in selectMap.translateJgtypeOption" :key="list.id" :value="list.id" :label="list.name"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div class="elFormBox">
                        <el-form-item  label="加工厂：" prop="factory_id">
                            <el-select v-model="form_params.factory_id" @visible-change="getSelectList('plant',$event)">
                                <el-option v-for="list in selectMap.plant" :key="list.id" :value="list.id" :label="list.name"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div class="elFormBox">
                        <el-form-item  label="烘干窑：" prop="drying_cave">
                            <el-input v-model="form_params.drying_cave" ></el-input>
                        </el-form-item>
                    </div>
                    <div class="elFormBox">
                        <el-form-item  label="预计耗时：" prop="inbound_time">
                            <el-input v-model="form_params.inbound_time"></el-input>
                        </el-form-item>
                    </div>
                </el-form>
                <div class="dialogFlow">
                    <div class="editBox">
                        <div class="editList">                      
                            <div class="outAndInTitle dialogForm" style="padding-bottom: 7px;">
                                <span class="within">领取原料</span>
                                <div class="globalFilterBtn"  v-if="module.indexOf(',system-column-set,')!=-1" @click="filterDialogVisibleA=!filterDialogVisibleA;sceneIn = 'translate.package.out';isGlobal = true;columnType=[1];getBillColumn();"></div>
                            </div>
                            <el-table :data="form_params.out.detail" :summary-method="getTableSummaries" border stripe show-summary highlight-current-row size="mini" height="100%" @header-dragend="headDrog">
                                <el-table-column type="index" label="序号" align="center" width="50"></el-table-column>
                                <el-table-column label="操作"  width="80">
                                    <template slot-scope="scope">
                                        <div class="icon_wrap">
                                            <i class="operation_add" @click="dialogVisibleStockOpen(1)" title="添加"></i>
                                            <i class="operation_delete" @click="listDetailDelete(scope.$index)" title="删除"></i>
                                        </div>
                                    </template>
                                </el-table-column>
                                <template v-for="(item) in filterA">
                                    <el-table-column :prop="item.field" v-if="item.show && billColumn.indexOf(item.field)" :key="item.field" :label="item.name"
                                                :sortable="false"
                                                :width="item.width && item.width>90 ?item.width:90+ 'px'"
                                                align="left"
                                                show-overflow-tooltip
                                            >
                                        <template slot-scope="scope">
                                            <div v-if="item.field == 'original_width_total'">
                                                <span @click="widthList = scope.row.width;dialogVisibleWidth=true;isCanEditTotalWidth=false;" style="text-decoration:underline;cursor:pointer;">
                                                    {{ scope.row.original_width_total }}
                                                </span>
                                            </div>
                                            <span v-else id="ceshidom">
                                                {{ scope.row[item.field] }}
                                            </span>
                                        </template>
                                    </el-table-column>
                                </template>
                            </el-table>
                            <div class="transferType"></div>
                            <div class="outAndInHander">
                                <div class="outAndInTitle dialogForm" style="padding-bottom: 7px;">
                                    <span class="within">成品入库</span>
                                </div>
                                <div class="editBtn">
                                    <!-- <el-button class="fun" style="line-height: 27px;margin-bottom: 5px;" @click="openbusinessRelation">关联加工费用</el-button> -->
                                    <div v-if="fee_list!=''&&fee_list.length>0" class="clearfix" style="float:left;">
                                        <div class="newFee" v-for="(list,index) in fee_list" :key="'_'+index">
                                            {{list.fee_name+':  ￥'+list.amount}}
                                            <img src="../../assets/top-delete-suspension.png"  class="newFeeImg" @click="delOutFee(index,list.id)"/>
                                        </div>
                                    </div>
                                    <!-- v-if="module.includes(',warehouse-import,')" -->
                                    <!-- <div class="execlInsertBtn" @click="openimport()">
                                        <span class="excel_btn"><i class="excel-icon"></i>EXECL码单导入</span>
                                    </div> -->
                                </div>
                                <!-- <div class="globalFilterBtns " v-if="module.indexOf(',system-column-set,')!=-1" @click="filterDialogVisible=!filterDialogVisible;sceneIn = 'translate.package.in';isGlobal = true;columnType=[2];getBillColumn();"></div> -->
                            </div>
                        </div>
                    </div>
                    <div class="remarkBox">
                        <textarea class="remarkTextarea" v-model="form_params.remark" cols="5"></textarea>
                    </div>
                </div>
                <div class="editBtnList clearfix">
                    <div class="editBtn">
                        <el-button class="funcPublicBtn" @click="transferConfirm(2)">锁定加工</el-button>
                        <!-- <el-button class="funcPublicBtn funcPublicBtnChecked" @click="openCheckout()">确认入库</el-button> -->
                        <!-- <el-button class="funcPublicBtn funcPublicBtnChecked" @click="transferConfirm(1)">审核完成</el-button> -->
                    </div>
                </div>
            </div>
        </el-dialog>
        <!-- dialog END -->
        <!-- dialog START -->
        <el-dialog v-dialog-drag :visible.sync="dialogVisibles" class="eldialog eldialogC  eldialogTransfer eldialogWidth" :modal="false" :title="'翻包加工单('+form_params.order_sn+')'" custom-class="full_dialog">
            <div class="dialogSearchBox">
                <div class="editBox">
                    <el-form class="clearfix dialogFormB dialogForm" :rules="formRules"  :model="form_params" ref="saleorderA">
                        <div class="elFormBox">
                            <!-- :disabled="!saleOrderIsEdit" -->
                            <el-form-item  label="订单日期：" prop="tran_date">
                                <el-date-picker :disabled="!isCanEdit" v-model="form_params.tran_date" type="date" size="mini"></el-date-picker>
                            </el-form-item>
                        </div>
                        <div class="elFormBox"> 
                            <el-form-item  label="加工类型：" prop="jg_type">
                                <el-select  :disabled="!isCanEdit" v-model="form_params.jg_type" @visible-change="getSelectList('translateJgtypeOption',$event)">
                                    <el-option v-for="list in selectMap.translateJgtypeOption" :key="list.id" :value="list.id" :label="list.name"></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <div class="elFormBox">
                            <el-form-item  label="加工厂：" prop="factory_id">
                                <el-select  :disabled="!isCanEdit" v-model="form_params.factory_id" @visible-change="getSelectList('plant',$event)">
                                    <el-option v-for="list in selectMap.plant" :key="list.id" :value="list.id" :label="list.name"></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <div class="elFormBox">
                            <el-form-item  label="烘干窑：" prop="drying_cave">
                                <el-input  :disabled="!isCanEdit" v-model="form_params.drying_cave" ></el-input>
                            </el-form-item>
                        </div>
                        <div class="elFormBox">
                            <el-form-item  label="预计耗时：" prop="inbound_time">
                                <el-input  :disabled="!isCanEdit" v-model="form_params.inbound_time"></el-input>
                            </el-form-item>
                        </div>
                    </el-form>
                    <div class="dialogFlow">
                        <div class="editList">
                            <div class="outAndInTitle dialogForm" style="padding-bottom: 7px;">
                                <span class="within">领取原料</span>
                                <div class="globalFilterBtn"  v-if="module.indexOf(',system-column-set,')!=-1" @click="filterDialogVisibleA=!filterDialogVisibleA;sceneIn = 'translate.package.out';isGlobal = true;columnType=[1];getBillColumn();"></div>
                            </div>
                            <el-table :data="form_params.out.detail" :summary-method="getTableSummaries" border stripe show-summary highlight-current-row size="mini" height="100%" @header-dragend="headDrog">
                                <el-table-column type="index" label="序号" align="center" width="50"></el-table-column>
                                <el-table-column label="操作"  width="80"  v-if="isCanEdit">
                                    <template slot-scope="scope">
                                        <div class="icon_wrap">
                                            <i class="operation_add" @click="dialogVisibleStockOpen(1)" title="添加"></i>
                                            <i class="operation_delete" @click="listDetailDelete(scope.$index)" title="删除"></i>
                                        </div>
                                    </template>
                                </el-table-column>
                                <template v-for="(item) in filterA">
                                    <el-table-column :prop="item.field" v-if="item.show && billColumn.indexOf(item.field)" :key="item.field" :label="item.name"
                                                :sortable="false"
                                                :width="item.width && item.width>90 ?item.width:90+ 'px'"
                                                align="left"
                                                show-overflow-tooltip
                                            >
                                        <template slot-scope="scope">
                                            <!-- <div v-if="item.field == 'original_width_total'">
                                                <span @click="widthObj.widthList = JSON.parse(JSON.stringify(scope.row.width));dialogVisibleWidth=true;isCanEditTotalWidth=false;widthObj.widthType=''" style="text-decoration:underline;cursor:pointer;">
                                                    {{ scope.row.original_width_total }}
                                                </span>
                                            </div> -->
                                            <div v-if="item.field == 'original_width_total'">
                                                    <span @click="widthList = scope.row.width;dialogVisibleWidth=true;isCanEditTotalWidth=false;" style="text-decoration:underline;cursor:pointer;">
                                                        {{ scope.row.original_width_total }}
                                                    </span>
                                                </div>
                                            <span v-else>
                                                {{ scope.row[item.field] }}
                                            </span>
                                        </template>
                                    </el-table-column>
                                </template>
                            </el-table>
                            <div class="transferType" >
                            </div>
                            <div class="outAndInHander">
                                <div class="outAndInTitle">
                                    <span class="within">成品入库</span>
                                </div>
                                <div class="editBtn">
                                    <el-button class="fun" style="line-height: 27px;margin-bottom: 5px;" @click="openData">成品明细</el-button>
                                    <el-button class="fun" style="line-height: 27px;margin-bottom: 5px;" @click="openbusinessRelation"  v-if="isCanEdit&&inventory_sum[0].number>0">关联翻包费用</el-button>
                                        <div v-if="fee_list.length>0" class="clearfix" style="float:left;margin-bottom: 5px;">
                                        <div class="newFee" v-for="(list,index) in fee_list" :key="'_'+index">
                                            {{list.fee_name+':  ￥'+list.amount}}
                                            <img src="../../assets/top-delete-suspension.png"  class="newFeeImg" @click="delOutFee(index,list.id)"/>
                                        </div>
                                    </div>
                                    <el-button class="fun" style="line-height: 27px;margin-bottom: 5px;" v-if="isCanEdit&&inventory_sum[0].number>0" @click="flatOut">平摊采购单价</el-button>
                                    <!-- <div class="execlInsertBtn" v-if="isCanEdit" @click="openimport()">
                                        <span class="excel_btn"><i class="excel-icon"></i>EXECL码单导入</span>
                                    </div> -->
                                </div>
                                <!-- <div class="globalFilterBtns " v-if="module.indexOf(',system-column-set,')!=-1"  @click="filterDialogVisible=!filterDialogVisible;sceneIn = 'translate.package.in';isGlobal = true;columnType=[2];getBillColumn();"></div> -->
                            </div>
                            <el-table :data="inventory_sum" border stripe highlight-current-row size="mini" height="100%">
                                <el-table-column prop="number" label="件数" width="120"></el-table-column>
                                <el-table-column prop="original_cube" label="码单立方" width="120"></el-table-column>
                                <el-table-column prop="purchase_amount" label="采购金额" width="120"></el-table-column>
                                <el-table-column prop="fee_amount" label="费用金额" width="120"></el-table-column>
                                <el-table-column prop="storage_number" label="已入库" width="120"></el-table-column>
                                <el-table-column prop="transit_number" label="待入库" width="120"></el-table-column>
                            </el-table>          
                            <div class="remarkBox">
                                <textarea class="remarkTextarea" v-model="form_params.remark" cols="5" :readonly="!isCanEdit" @blur="remarkBlur()"></textarea>
                            </div>
                        </div>
                    </div>
                    </div>
                    <span class="bottom" v-if="bottom.creator_name">制单人:{{bottom.creator_name}}</span> 
                    <span class="bottom" v-if="bottom.tran_date">转出时间:{{bottom.tran_date}}</span>
                    <span class="bottom" v-if="bottom.transfer_name">入库人:{{bottom.transfer_name}}</span>
                    <span class="bottom" v-if="bottom.inbound_time">入库时间:{{bottom.inbound_time}}</span>
                    <span class="bottom" v-if="bottom.profit_amount">
                        加工盈亏:<span style="color: red;" v-if="bottom.profit_amount<0">{{bottom.profit_amount}}</span>
                                <span v-else>{{bottom.profit_amount}}</span>
                    </span>
                <div class="editBtnList clearfix">
                    <div class="editBtn">
                        <el-button class="funcPublicBtn" @click="transferExport">导出</el-button>
                        <!-- <el-button class="funcPublicBtn" @click="print">打印</el-button> -->
                        <el-button class="funcPublicBtn" v-if="dels"  @click="deleteUpdate">删除</el-button>
                        <el-button class="funcPublicBtn" v-if="isCanEdit" @click="transferConfirmUpdate(2)">锁定加工</el-button>
                        <el-button class="funcPublicBtn funcPublicBtnChecked" v-if="isCanEdit" @click="auditTime()">审核完成</el-button>
                    </div>
                </div>
            </div>
        </el-dialog>
        <!-- dialog END -->
         <!-- dialog START -->
        <el-dialog v-dialog-drag :visible.sync="dialogTemplateVisibles" class="eldialog eldialogC  eldialogTransfer eldialogWidth" :modal="false" title="翻包加工单" custom-class="full_dialog">
            <div class="dialogSearchBox">
                    <div class="editBox">
                        <el-form :rules="formTemplateRules" :model="form_template_params" ref="saleorderB" class="clearfix dialogFormB dialogForm">
                            <div class="elFormBox">
                                <!-- :disabled="!saleOrderIsEdit" -->
                                <el-form-item  label="订单日期：" prop="tran_date">
                                    <el-date-picker  v-model="form_template_params.tran_date" type="date" size="mini"></el-date-picker>
                                </el-form-item>
                            </div>
                            <div class="elFormBox"> 
                                <el-form-item  label="加工类型：" prop="jg_type">
                                    <el-select v-model="form_template_params.jg_type" @visible-change="getSelectList('translateJgtypeOption',$event)">
                                        <el-option v-for="list in selectMap.translateJgtypeOption" :key="list.id" :value="list.id" :label="list.name"></el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                            <div class="elFormBox">
                                <el-form-item  label="加工厂：" prop="factory_id">
                                    <el-select v-model="form_template_params.factory_id" @visible-change="getSelectList('plant',$event)">
                                        <el-option v-for="list in selectMap.plant" :key="list.id" :value="list.id" :label="list.name"></el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                            <div class="elFormBox">
                                <el-form-item  label="烘干窑：" prop="drying_cave">
                                    <el-input v-model="form_template_params.drying_cave" ></el-input>
                                </el-form-item>
                            </div>
                            <div class="elFormBox">
                                <el-form-item  label="预计耗时：" prop="inbound_time">
                                    <el-input v-model="form_template_params.inbound_time"></el-input>
                                </el-form-item>
                            </div>
                        </el-form>
                        <div class="dialogFlow">
                            <div class="editList">
                                <div class="outAndInTitle dialogForm" style="padding-bottom: 7px;">
                                    <span class="within">领取原料</span>
                                    <div class="globalFilterBtn"  v-if="module.indexOf(',system-column-set,')!=-1" @click="filterDialogVisibleA=!filterDialogVisibleA;sceneIn = 'translate.package.out';isGlobal = true;columnType=[1];getBillColumn();"></div>
                                </div>
                                <el-table :data="form_template_params.out.detail" :summary-method="getTableSummaries" border stripe show-summary highlight-current-row size="mini" height="100%" @header-dragend="headDrog">
                                    <el-table-column type="index" label="序号" align="center" width="50"></el-table-column>
                                    <el-table-column label="操作"  width="80">
                                        <template slot-scope="scope">
                                            <div class="icon_wrap">
                                                <i class="operation_add" @click="dialogVisibleStockOpen(2)" title="添加"></i>
                                                <i class="operation_delete" @click="listTemplateDetailDelete(scope.$index)" title="删除"></i>
                                            </div>
                                        </template>
                                    </el-table-column>
                                    <template v-for="(item) in filterA">
                                        <el-table-column :prop="item.field" v-if="item.show && billColumn.indexOf(item.field)" :key="item.field" :label="item.name"
                                                    :sortable="false"
                                                    :width="item.width && item.width>90 ?item.width:90+ 'px'"
                                                    align="left"
                                                    show-overflow-tooltip
                                                >
                                            <template slot-scope="scope">
                                                <!-- <div v-if="item.field == 'original_width_total'">
                                                    <span @click="widthObj.widthList = JSON.parse(JSON.stringify(scope.row.width));dialogVisibleWidth=true;isCanEditTotalWidth=false;widthObj.widthType=''" style="text-decoration:underline;cursor:pointer;">
                                                        {{ scope.row.original_width_total }}
                                                    </span>
                                                </div> -->
                                                <div v-if="item.field == 'original_width_total'">
                                                    <span @click="widthList = scope.row.width;dialogVisibleWidth=true;isCanEditTotalWidth=false;" style="text-decoration:underline;cursor:pointer;">
                                                        {{ scope.row.original_width_total }}
                                                    </span>
                                                </div>
                                                <span v-else id="ceshidom">
                                                    {{ scope.row[item.field] }}
                                                </span>
                                            </template>
                                        </el-table-column>
                                    </template>
                                </el-table>
                                <div class="transferType" >
                                </div>
                                <div class="outAndInHander">
                                    <div class="outAndInTitle">
                                        <span class="within">成品入库</span>
                                    </div>
                                    <div class="editBtn">
                                        <el-button :class="['transferBtn','funcPublicBtn']" style="line-height: 27px;margin-bottom: 5px;" @click="resetAndModify()">重置修改</el-button>
                                    </div>
                                    <div class="globalFilterBtns " v-if="module.indexOf(',system-column-set,')!=-1"  @click="filterDialogVisible=!filterDialogVisible;sceneIn = 'translate.package.down';isGlobal = true;columnType=[2];getBillColumn();"></div>
                                </div>
                                <el-table :data="form_template_params.in.detail" :summary-method="getTableSummariesB" border stripe show-summary highlight-current-row size="mini" height="100%" @header-dragend="headDrogB">
                                    <el-table-column type="index" label="序号" align="center" width="50"></el-table-column>
                                    <el-table-column label="操作"  width="75" >
                                        <template slot-scope="scope">
                                            <div class="icon_wrap">
                                                <i class="operation_add" @click="copyData(scope.row)" title="添加"></i>
                                                <i class="operation_delete" @click="listDetailTemplateInDelete(scope.$index)" title="删除"></i>
                                            </div>
                                        </template>
                                    </el-table-column>
                                    <template v-for="(item) in filterB">
                                        <el-table-column :prop="item.field" v-if="item.show && tiltingColumn.indexOf(item.field)" :key="item.field" :label="item.name"
                                                    :sortable="false"
                                                    :width="item.width && item.width>90 ?item.width:90+ 'px'"
                                                    align="left"
                                                    show-overflow-tooltip
                                                >
                                            <template slot-scope="scope">
                                                <div v-if="item.field == 'bale_no'">
                                                    <el-input v-model="scope.row.bale_no" ></el-input>
                                                </div>
                                                <div v-else-if="item.field == 'breed'">
                                                    <el-select  v-model="scope.row.breed_id" placeholder="品名" :disabled="isCanEdit" @visible-change="getSelectList('breed')">
                                                        <el-option v-for="list in selectMap.breed" :key="list.id" :value="list.id" :label="list.name"></el-option>
                                                    </el-select>
                                                </div>
                                                <div v-else-if="item.field == 'brand'">
                                                    <el-select  v-model="scope.row.brand_id" placeholder="品牌" :disabled="isCanEdit" @visible-change="getSelectList('brand')">
                                                        <el-option v-for="list in selectMap.brand" :key="list.id" :value="list.id" :label="list.name"></el-option>
                                                    </el-select>
                                                </div>
                                                <div v-else-if="item.field == 'grade'">
                                                    <el-select  v-model="scope.row.grade_id" placeholder="等级" :disabled="isCanEdit" @visible-change="getSelectList('grade')">
                                                        <el-option v-for="list in selectMap.grade" :key="list.id" :value="list.id" :label="list.name"></el-option>
                                                    </el-select>
                                                </div>
                                                <div v-else-if="item.field == 'original_thickness'">
                                                    <el-input v-model="scope.row.original_thickness"  :disabled="scope.row.category_id==2"></el-input>
                                                </div>
                                                <div v-else-if="item.field == 'original_length'">
                                                    <el-input v-model="scope.row.original_length"  :disabled="scope.row.category_id==2"></el-input>
                                                </div>
                                                <div v-else-if="item.field == 'original_width_total'">
                                                    <span @click="widthClick(scope.row,scope.$index)" style="text-decoration:underline;cursor:pointer;">
                                                        {{scope.row.original_width_total}}
                                                    </span>
                                                </div>
                                                <div v-else-if="item.field == 'sales_width_total'">
                                                    <span @click="salesWidthClick(scope.row,scope.$index)" style="text-decoration:underline;cursor:pointer;">
                                                        {{scope.row.sales_width_total}}
                                                    </span>
                                                </div>
                                                <div v-else-if="item.field == 'pieces'">
                                                    <el-input v-model="scope.row.pieces" :disabled="scope.row.category_id==2"></el-input>
                                                </div>
                                                <div v-else-if="item.field == 'layer_number'">
                                                    <el-input v-model="scope.row.layer_number" :disabled="scope.row.category_id==2"></el-input>
                                                </div>
                                                <div v-else-if="item.field == 'original_cube'">
                                                    <el-input v-model="scope.row.original_cube" :disabled="scope.row.category_id==2" @input="purchaseAmountCalculation($event)"></el-input>
                                                </div>
                                                <div v-else-if="item.field == 'sales_cube'">
                                                    <el-input v-model="scope.row.sales_cube" :disabled="scope.row.category_id==2"></el-input>
                                                </div>
                                                <div v-else-if="item.field == 'cost'">
                                                    <el-input v-model="scope.row.cost" ></el-input>
                                                </div>
                                                <div v-else-if="item.field == 'sales_price'">
                                                    <el-input v-model="scope.row.sales_price" ></el-input>
                                                </div>
                                                <div v-else-if="item.field == 'cube_price'">
                                                    <el-input v-model="scope.row.cube_price" @input="purchaseAmountCalculation($event)"></el-input>
                                                </div>
                                                <div v-else-if="item.field == 'purchase_amount'">
                                                    <el-input v-model="scope.row.purchase_amount" disabled></el-input>
                                                </div>
                                                <!-- <div v-else-if="item.field == 'supplier'">
                                                    <el-select  v-model="scope.row.supplier_id" placeholder="供应商" :disabled="isCanEdit" @visible-change="getSelectList('supplier')">
                                                        <el-option v-for="list in selectMap.supplier" :key="list.id" :value="list.id" :label="list.name"></el-option>
                                                    </el-select>
                                                </div> -->
                                                <div v-else-if="item.field == 'supplier'">
                                                    <el-select  v-model="scope.row.supplier_id" placeholder="供应商" :disabled="isCanEdit" @visible-change="getSelectList('supplier')">
                                                        <el-option v-for="list in selectMap.supplier" :key="list.id" :value="list.id" :label="list.name"></el-option>
                                                    </el-select>
                                                </div>
                                                <div v-else-if="item.field == 'bill_lading_no'">
                                                    <el-input v-model="scope.row.bill_lading_no" ></el-input>
                                                </div>
                                                <div v-else-if="item.field == 'container_no'">
                                                    <el-input v-model="scope.row.container_no" ></el-input>
                                                </div>
                                                <div v-else-if="item.field == 'color'">
                                                    <el-select  v-model="scope.row.color_id" placeholder="选色" :disabled="isCanEdit" @visible-change="getSelectList('color')">
                                                        <el-option v-for="list in selectMap.color" :key="list.id" :value="list.id" :label="list.name"></el-option>
                                                    </el-select>
                                                </div>
                                                <div v-else-if="item.field == 'attribute'">
                                                    <el-select  v-model="scope.row.attribute_id" placeholder="属性" :disabled="isCanEdit" @visible-change="getSelectList('attribute')">
                                                        <el-option v-for="list in selectMap.attribute" :key="list.id" :value="list.id" :label="list.name"></el-option>
                                                    </el-select>
                                                </div>
                                                <div v-else-if="item.field == 'warehouse'">
                                                    <el-select  v-model="scope.row.warehouse_id" placeholder="仓库" :disabled="isCanEdit" @visible-change="getSelectList('warehouse')">
                                                        <el-option v-for="list in selectMap.warehouse" :key="list.id" :value="list.id" :label="list.name"></el-option>
                                                    </el-select>
                                                </div>
                                                <div v-else-if="item.field == 'remark'">
                                                    <el-input v-model="scope.row.remark" ></el-input>
                                                </div>
                                                <span v-else>
                                                    {{ scope.row[item.field] }}
                                                </span>
                                            </template>
                                        </el-table-column>
                                    </template>
                                </el-table>         
                            </div>
                        </div>
                    </div>
                    <!-- <div class="remarkBox">
                        <textarea class="remarkTextarea" v-model="form_template_params.remark" cols="5" :readonly="!isCanEdit"></textarea>
                    </div> -->
                <div class="editBtnList clearfix">
                    <div class="editBtn">
                        <el-button class="funcPublicBtn " @click="dialogTemplateVisibles=!dialogTemplateVisibles">取消</el-button>
                        <el-button class="funcPublicBtn funcPublicBtnChecked" @click="storeSave(2)">锁定保存</el-button>
                    </div>
                </div>
            </div>
        </el-dialog>
        <!-- dialog END -->

        <!--选择库存START-->
        <el-dialog v-dialog-drag  :visible.sync="dialogVisibleStock" class="eldialog eldialogStock" width="1160px" :modal="false" title="选择货物" custom-class="full_dialog">
            <transfer-select-stock ref="selectStock" @cancel="dialogVisibleStock=!dialogVisibleStock" @selectData="selectData" @selectAndOut="selectAndOut"></transfer-select-stock>
        </el-dialog>
        <!--选择库存END-->
        
        <!-- 宽度列表START -->
        <el-dialog v-dialog-drag :visible.sync="dialogVisibleWidth" class="eldialog totalWidthDialog" width="820px" :modal="false" custom-class="full_dialog">
            <total-widthnew :edit="isCanEditTotalWidth" :codeSheetType="2" :dialogvisible="dialogVisibleWidth" :list="widthList" @returnIs_sales="res=>{returnIs_sales(res)}" @returnwidth="res=>{widthReturn(res)}" @cancelWidth="()=>{this.dialogVisibleWidth = false;}"></total-widthnew>
        </el-dialog>
        <!-- 宽度列表END -->
        <!-- 销售宽度列表START -->
        <el-dialog v-dialog-drag :visible.sync="saleDialogVisibleWidth" class="eldialog totalWidthDialog" width="820px" :modal="false" custom-class="full_dialog">
            <total-widthnew :edit="isSaleCanEditTotalWidth" :dialogvisible="saleDialogVisibleWidth" :list="widthList" @returnwidth="res=>{saleWidthReturn(res)}" :type="1"  @cancelWidth="()=>{this.saleDialogVisibleWidth = false;}"></total-widthnew>
        </el-dialog>
        <!-- 销售宽度列表END -->

         <!--添加费用START-->
        <el-dialog v-dialog-drag :visible.sync="businessRelation" class="eldialog eldialogLine" :modal="false" title="添加成本费用" custom-class="full_dialog">
            <div class="dialogSearchBox">
                <el-form ref="feeOutForm" :model="businessRelationForm" :rules="feeOutFormRlues" class="clearfix dialogFormB">
                    <el-form-item  label="日期：" prop="fee_date">
                        <el-date-picker v-model="businessRelationForm.fee_date" type="date" placeholder="" size="mini"></el-date-picker>
                    </el-form-item>
                    <el-form-item  label="费用名称：" prop="fee_id">
                        <el-select v-model="businessRelationForm.fee_id" @input="outFeeChange" @visible-change="outFeeSelectFunc" clearable>
                            <el-option v-for="list in outFeeSelect" :key="list.id" :value="list.id" :label="list.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="收款人(单位)：" prop="payee">
                        <el-input v-model="businessRelationForm.payee"></el-input>
                    </el-form-item>
                    <!-- <el-form-item  label="关联销售人：">
                        <el-select v-model="businessRelationForm.salesman_id" filterable @visible-change="outSalesmanFunc" @change="outSalesmanChange" clearable>
                            <el-option v-for="list in salesman" :key="list.id" :value="list.id" :label="list.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="关联客户名称：">
                        <el-select v-model="businessRelationForm.customer_id" filterable @visible-change="outCustomerFunc" @change="outCustomerChange" clearable>
                            <el-option v-for="list in customer" :key="list.id" :value="list.id" :label="list.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="关联销售单号：">
                        <el-select v-model="businessRelationForm.order_id" filterable @visible-change="outOrderSnFunc" @change="outOrderSnChange" clearable>
                            <el-option v-for="list in orderSn" :key="list.id" :value="list.id" :label="list.name"></el-option>
                        </el-select>
                    </el-form-item> -->
                    <el-form-item  label="费用金额(￥)：" prop="amount">
                        <el-input v-model="businessRelationForm.amount"></el-input>
                    </el-form-item>
                    <el-form-item  label="提供发票：" prop="is_invoice">
                        <el-select v-model="businessRelationForm.is_invoice">
                            <el-option value="1" label="是"></el-option>
                            <el-option value="0" label="否"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="备注：" prop="remark">
                        <el-input v-model="businessRelationForm.remark"></el-input>
                    </el-form-item>
                    <div class="elFormBoxBtnListCol">
                        <el-button class="funcPublicBtn" @click="businessRelation=!businessRelation" style="margin-right:15px!important;">取消</el-button>
                        <el-button class="funcPublicBtn funcPublicBtnChecked"  @click="newOutFee">确认</el-button>
                    </div>
                </el-form>
            </div>
        </el-dialog>
        <!--添加费用END-->
        <!-- 字段过滤 START -->
        <filter-fields :tableData="filterA" :scene="sceneA" :isGlobal="true" :filterDialogVisible="filterDialogVisibleA" @confirm="filterConfirm" @dialogChangeFunc="val=>{this.filterDialogVisibleA = val;}"></filter-fields>
        <filter-fields :tableData="filterB" :scene="sceneB" :isGlobal="true" :filterDialogVisible="filterDialogVisible" @confirm="filterConfirm" @dialogChangeFunc="val=>{this.filterDialogVisible = val;}"></filter-fields>
        <!-- 字段过滤 END -->
        <!-- 字段过滤 START -->
        <filter-fields :tableData="filter" scene="translate.package.list" :filterDialogVisible="filterDialogVisibleOut" @confirm="filterConfirm" @dialogChangeFunc="val=>{this.filterDialogVisibleOut = val;}"></filter-fields>
        <!-- 字段过滤 END -->
        <!-- 入库确认框 dialog START -->
        <el-dialog v-dialog-drag title="完成时间确认" :visible.sync="checkoutDialog" class="eldialog eldialogLine" :modal="false" custom-class="full_dialog">
            <el-form :model="time" ref="add_form" class="dialogFormB clearfix">
                <div class="eldialogFormBox">
                    <el-form-item label="完成时间：">
                        <el-date-picker v-model="time.date" type="date" ></el-date-picker>
                    </el-form-item>
                </div>
            </el-form>
            <div class="dialogBtnList clearfix">
                <el-button class="dialogBtn funcPublicBtn" @click="checkoutDialog=!checkoutDialog">取消</el-button>
                <el-button  class="publicBtn dialogBtn" @click="auditCompleted()">确定</el-button>
            </div>
        </el-dialog>
        <!-- 入库确认框 dialog END -->
        <!-- 入库确认框 dialog START -->
        <el-dialog v-dialog-drag title="翻包加工入库确认" :visible.sync="checkoutDialogB" class="eldialog eldialogLine" :modal="false" custom-class="full_dialog">
            <el-form :model="form_params" ref="add_form" class="dialogFormB clearfix">
                <div class="eldialogFormBox">
                    <el-form-item label="选择仓库：">
                        <el-select  v-model="form_params.warehouse_id" placeholder="仓库"  @visible-change="getSelectList('warehouse')">
                            <el-option v-for="list in selectMap.warehouse" :key="list.id" :value="list.id" :label="list.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="入库时间：">
                        <el-date-picker v-model="form_params.inbound_time" type="date" ></el-date-picker>
                    </el-form-item>
                </div>
            </el-form>
            <div class="dialogBtnList clearfix">
                <el-button class="dialogBtn funcPublicBtn" @click="checkoutDialogB=!checkoutDialogB">取消</el-button>
                <el-button  class="publicBtn dialogBtn" @click="transferConfirmUpdate(1)">确定</el-button>
            </div>
        </el-dialog>
        <!-- 入库确认框 dialog END -->
        <!--execl START-->
        <el-dialog v-dialog-drag title="码单导入" :visible.sync="importDialogVisible" class="eldialog eldialogExcel" :modal="false" width='680px'>
			<div class="text-center"  style="margin-top:20px;">
                <div class="tab_box">
                    <div v-if="boardAmericaType" :class="{active: active == 1 }" @click="active=1">北美材码单模板</div>
                    <div v-if="boardZelkovaType" :class="{active: active == 2 }" @click="active=2">榉木码单模板</div>
                    <!-- <div v-if="boardAfricaType" :class="{active: active == 3 }" @click="active=3">非洲材码单模板</div> -->
                    <!-- <div v-if="categoryRawType" :class="{active: active == 4 }" @click="active=4">原木码单模板</div> -->
                    <div v-if="nationalStandardType" :class="{active: active == 5 }" @click="active=5">国标/非洲材码单模板</div>
                </div>
                <div class="text-center relative" style="padding: 80px 150px 65px;">
                    <el-upload class="upload-demo" ref='upload_path' drag :action="oss.host" :data="upload_data" :on-success="handleSuccess" :before-upload="beforeUpload" accept=".xls,.xlsx">
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text"  style="font-size:12px; color:#333;">将文件拖到此处，或<em style="color: #b21111;text-decoration: underline;">导入上传码单</em></div>
                        <div class="el-upload__tip" slot="tip"  style="color: #888;margin-top:5px;">只能上传Excel文件</div>
                    </el-upload>
                    <div class="">
                        <el-link type="primary" @click='downTemplete' style="color:#b21111;font-weight:bold; cursor:pointer;text-decoration: underline;">下载码单模板</el-link>
                    </div>
                </div>
			</div>
            <div class="dialogBtnList clearfix">
                <el-button  class="publicBtn dialogBtn" @click="importFile">确定</el-button>
                <el-button class="dialogBtn funcPublicBtn" @click="importDialogVisible=!importDialogVisible">取消</el-button>
            </div>
		</el-dialog>
        <!--execl END-->
        <!-- 同步销售总宽度 START -->
        <el-dialog v-dialog-drag :visible.sync="salesEditDialog" class="eldialog eldialogOneLabel totalChangeWidth spec" width="300px" :modal="false" title="是否确定修改" custom-class="full_dialog">
            <div class="whole">
                <el-checkbox v-model="is_sales"
                         class="confirmCheckBox">修改数据同步到销售宽度明细
                </el-checkbox>
            </div>
            <div class="dialogBtnList clearfix">
                <el-button  class="publicBtn dialogBtn" @click="widthEdit(salesEditContent)">确定</el-button>
                <el-button class="dialogBtn funcPublicBtn" @click="salesEditDialog = false">取消</el-button>
            </div>
        </el-dialog>
        <!-- 同步销售总宽度 END -->
    </div>
</template>
<script>
    import bus from "../../eventBus";
    import tabletem from '../../components/table.vue'
    import pagination from '../../components/pagination.vue'
    const initBusinessRelationForm = {
        fee_date: "",
        fee_id: "",
        fee_name: "",
        payee: "",
        amount: "",
        is_invoice: "",
        remark: ""
    };
    export default {
        data(){
            return{
                tableLoading:false,
                isShowMore:false,
                module:localStorage.dw_erp_power_code,
                dialogVisibleWidth:false,
                saleDialogVisibleWidth:false,//销售总宽弹框
                isSaleCanEditTotalWidth:false,
                widthList:[],
                salesEditDialog:false,
                is_sales:true,
                salesEditContent:[],
                dialogVisibleChoose:false,
                widthObj:{
                    widthList:[],
                    widthType:2,//2.码单 3.销售
                },
                noChuanshen:true,
                // widthType:2,
                scene:"",
                filter:[],
                filterDialogVisibleOut:false,
                filterA:[],
                filterB:[],
                filtersA:[],
                filtersB:[],
                filterDialogVisible:false,
                filterDialogVisibleA:false,
                isGlobal:false,
                billColumn:"",
                tiltingColumn:"",
                columnType:[1,2],
                sceneList:[
                    {name:"translate.package.down",number:2},
                    {name:"translate.package.out",number:1}
                ],
                sceneA:"translate.package.out",
                sceneB:"translate.package.down",
                copy_filter:"",
                isCanEditTotalWidth:true,
                upodateType:2,
                indetailType:"",
                start_time:"",
                end_time:"",
                start_over_time:"",
                end_over_time:"",
                params:{
                    start_time:"",
                    end_time:"",
                    start_over_time:"",
                    end_over_time:"",
                    order_sn:"",
                    translator_id:"",
                    status:[],
                    page:1,
                    per_page:50
                },
                breedList:[],
                gradeList:[],
                warehouseList:[],
                selectMap:{
                    translate:[],
                    brand:[],
                    breed:[],
                    grade:[],
                    supplier:[],
                    warehouse:[],
                    attribute:[],
                    location:[],
                    creator:[],
                    translateJgtypeOption:[],//加工类型
                    plant:[],//加工厂
                },
                selectMapC:{
                    jg_type:[],
                    transfer_id:[],
                    creator_id:[],
                    reviewer_id:[],
                    status:[],
                    factory_id:[],
                    drying_cave:[],
                    in_warehouse_id:[],
                },
                dialogVisible:false,
                dialogVisibles:false,
                centerDialogVisible:false,
                dialogVisibleStock:false,
                openStockType:'',
                last_page:1,
                total:0,
                selectRow:[],
                form_params:{
                    out:{
                        detail:[
                            {
                                id:"",
                                bale_no:"",
                                brand_id:"",
                                brand:"",
                                breed:"",
                                breed_id:"",
                                grade_id:"",
                                grade:"",
                                original_thickness:"",
                                original_length:"",
                                original_width_total:"",
                                width:[],
                                pieces:"",
                                original_cube:"",
                                sales_cube:"",
                                cube_price:"",
                                cost:"",
                                cost_price:"",
                                ship_no:"",
                                status:"",
                                warehouse:"",
                                warehouse_id:"",
                                remark:"",
                                status_text:"",
                                color:"",
                                attribute:"",
                                sales_price:"",
                            }
                        ]
                    },
                    in:{
                        detail:[
                            {
                                bale_no:"",
                                breed_id:"",
                                brand_id:"",
                                grade_id:"",
                                original_thickness:"0",
                                original_length:"0",
                                original_width_total:0,
                                width:[
                                    {cube:0,layer_number:0,length:"0",spec:"",thickness:"0",veneer_avg:"",width:[],width_other:""}
                                ],
                                sales_width_total:0,
                                sales_width:[
                                    {cube:0,layer_number:0,length:"0",spec:"",thickness:"0",veneer_avg:"",width:[],width_other:""}
                                ],
                                pieces:"",
                                layer_number:"",
                                original_cube:"",
                                sales_cube:"",
                                sales_price:"",
                                color_id:"",
                                attribute_id:"",
                                warehouse_id:"",
                                remark:"",
                            }
                        ]
                    },
                    remark:"",
                    tran_date:new Date(),
                    jg_type:'',
                    // factory_id:'',
                    drying_cave:'',
                    inbound_time:'',
                    // inbound_time:new Date(),
                    // warehouse_id:'',
                },
                dialogTemplateVisibles:false,
                form_template_params:{
                    out:{
                        detail:[
                            {
                                id:"",
                                bale_no:"",
                                brand_id:"",
                                brand:"",
                                breed:"",
                                breed_id:"",
                                grade_id:"",
                                grade:"",
                                original_thickness:"",
                                original_length:"",
                                original_width_total:"",
                                width:[],
                                pieces:"",
                                original_cube:"",
                                sales_cube:"",
                                cube_price:"",
                                cost:"",
                                cost_price:"",
                                ship_no:"",
                                status:"",
                                warehouse:"",
                                warehouse_id:"",
                                remark:"",
                                status_text:"",
                                color:"",
                                attribute:"",
                                sales_price:"",
                            }
                        ]
                    },
                    in:{
                        detail:[
                            {
                                bale_no:"",
                                breed_id:"",
                                brand_id:"",
                                grade_id:"",
                                original_thickness:"0",
                                original_length:"0",
                                original_width_total:0,
                                width:[
                                    {cube:0,layer_number:0,length:"0",spec:"",thickness:"0",veneer_avg:"",width:[],width_other:""}
                                ],
                                sales_width_total:0,
                                sales_width:[
                                    {cube:0,layer_number:0,length:"0",spec:"",thickness:"0",veneer_avg:"",width:[],width_other:""}
                                ],
                                pieces:"",
                                layer_number:"",
                                original_cube:"",
                                sales_cube:"",
                                sales_price:"",
                                color_id:"",
                                attribute_id:"",
                                warehouse_id:"",
                                remark:"",
                            }
                        ]
                    },
                    remark:"",
                    tran_date:new Date(),
                    jg_type:'',
                    // factory_id:'',
                    drying_cave:'',
                    inbound_time:'',
                    // inbound_time:new Date(),
                    // warehouse_id:'',
                },
                isCanEdit:false,
                Edits:false,
                transferNumber:"",
                transferType:"",//1.组装 2.拆卸
                list:[],
                tableCol:[
                    {colName:"订单日期",colKey:"tran_date",colWidth:160,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"订单状态",colKey:"status_text",colWidth:160,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"加工类型",colKey:"jg_type_text",colWidth:160,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"翻包加工单号",colKey:"order_sn",colWidth:160,isSetWidth:true,isCanClick:true,isShow:true,isColor:true},
                    {colName:"原料方数",colKey:"cube",colWidth:160,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"成品方数",colKey:"new_cube",colWidth:160,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"成材率",colKey:"outturn_rate_text",colWidth:160,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"入库确认人",colKey:"transfer_name",colWidth:150,isSetWidth:true,isCanClick:false,isShow:true,isColor:false},
                    {colName:"耗时天数",colKey:"finish_days",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true,isColor:false},
                    {colName:"完成日期",colKey:"over_time",colWidth:120,isSetWidth:true,isCanClick:false,isShow:true,isColor:false},
                    {colName:"制单人",colKey:"creator_name",colWidth:150,isSetWidth:true,isCanClick:false,isShow:true,isColor:false},
                    {colName:"加工厂",colKey:"factory_name",colWidth:150,isSetWidth:true,isCanClick:false,isShow:true,isColor:false},
                    {colName:"烘干窑",colKey:"drying_cave",colWidth:150,isSetWidth:true,isCanClick:false,isShow:true,isColor:false},
                    {colName:"仓库",colKey:"in_warehouse",colWidth:150,isSetWidth:true,isCanClick:false,isShow:true,isColor:false},
                    {colName:"审核人",colKey:"reviewer_name",colWidth:150,isSetWidth:true,isCanClick:false,isShow:true,isColor:false},
                    {colName:"翻包加工费",colKey:"amount",colWidth:150,isSetWidth:true,isCanClick:false,isShow:true,isColor:false},
                    {colName:"仓库",colKey:"in_warehouse",colWidth:150,isSetWidth:true,isCanClick:false,isShow:true,isColor:false},
                    {colName:"操作日期",colKey:"create_time",colWidth:160,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"备注",colKey:"remark",colWidth:150,isSetWidth:true,isCanClick:false,isShow:true,isColor:false},
                    {colName:"加工盈亏",colKey:"profit_amount",colWidth:150,isSetWidth:true,isCanClick:false,isShow:true,isColor:false},
                ],
                totalObj:{},
                listDetail:[],
                errorMessage:"",
                flag:false,
                removeTotalOriginal:"",
                removeOriginal:"",
                removeThicknessOriginal:"",
                removeLengthOriginal:"",
                removePiecesOriginal:"",
                isShowEdit:false,
                sure_params : {
                    in_warehouse:'',
                    warehouse_local:'',
                    inbound_time:new Date()
                },
                bottom:{
                    inbound_time:"",
                    creator_name:"",
                    transfer_name:"",
                    tran_date:""
                }, 
                in_warehouse_name:"",
                businessRelation: false,
                businessRelationForm: this.$cloneJson(initBusinessRelationForm),
                formRules: {
                    tran_date:[{required: true, message: '订单日期不能为空', trigger: 'blur' }],
                    jg_type:[{required: true, message: '不能为空', trigger: 'change' }],
                },
                formTemplateRules: {
                    tran_date:[{required: true, message: '订单日期不能为空', trigger: 'blur' }],
                    jg_type:[{required: true, message: '不能为空', trigger: 'change' }],
                },
                feeOutFormRlues: {
                    fee_id: [{required: true, message: '请选择费用名称', trigger: 'blur'}],
                    payee: [{required: true, message: '请填写收款人', trigger: 'blur'}],
                    amount: [{required: true, message: '请填写金额', trigger: 'blur'}],
                    is_invoice: [{required: true, message: '请选择是否开票', trigger: 'blur'}],
                },
                outFeeSelect: [],
                fee_list:[],
                editid:"",
                in_warehouse_id:"",
                warehouse_local:"",
                creator_name:"",
                status:"",
                Edit:"",
                dels:"",
                goodsId:"",
                orderSn:[],
                customer:[],
                salesman:[],
                checkoutDialog:false,//入库确认框
                checkoutDialogB:false,//入库确认框
                importDialogVisible:false,
                boardAmericaType:localStorage.dw_erp_board.indexOf("board-america")!=-1?true:false,
                boardZelkovaType:localStorage.dw_erp_board.indexOf("board-america")!=-1?true:false,
                boardAfricaType:localStorage.dw_erp_board.indexOf("board-africa")!=-1?true:false,
                categoryRawType:localStorage.dw_erp_category.indexOf("raw")!=-1?true:false,
                nationalStandardType:localStorage.dw_erp_board.indexOf("board-africa")!=-1?true:false,
                active : "",
                downloadName:"",
                downloadUCode:"",
                oss : {
                    host : "",
                },
                upload_data : {},
                add_params:{},
                inventory_sum:[],
                time:{
                    date:new Date(),
                },
                action:'',
            }
        },
        created(){
            this.getSelectList("breed")
            this.getSelectList("brand")
            this.getSelectList("grade")
            this.getSelectList("warehouse")
            this.getSelectList("attribute")
            this.getSelectList("color")
            this.getSelectList("translateJgtypeOption")
            this.getSelectList("plant")
            this.getSelectList("supplier")
            this.getSelectTranslateList('jg_type')
            this.tableColCopy = this.$deepClone(this.tableCol);
            this.getList();
            this.sceneList.forEach(item=>{
                this.sceneIn = item.name;
                this.columnType = [item.number]
                this.isGlobal = true;
                this.getBillColumn()
            })
        },
        methods:{
            headDrog(newWidth, oldWidth, column) {
                this.filterA.forEach((item) => {
                    if (column.property == item.colKey) {
                        item.colWidth = newWidth;
                    }
                });
                let obj = {};
                obj.width = parseInt(newWidth);
                obj.name = column.property;
                let emit = ("changeHeadWidth" + this.sceneA).replace(/\./g, "");
                bus.$emit(emit, obj);
            },
            headDrogB(newWidth, oldWidth, column) {
                this.filterB.forEach((item) => {
                    if (column.property == item.colKey) {
                        item.colWidth = newWidth;
                    }
                });
                let obj = {};
                obj.width = parseInt(newWidth);
                obj.name = column.property;
                let emit = ("changeHeadWidth" + this.sceneB).replace(/\./g, "");
                bus.$emit(emit, obj);
            },
            openDialogVisibleWidth(){
                this.form_params.in.detail.forEach(item=>{
                    if(item.width.length==0){
                        item.width=[{cube:0,layer_number:0,length:"0",spec:"",thickness:"0",veneer_avg:"",width:[]}]
                    }
                    if(item.sales_width.length==0){
                        item.sales_width=[{cube:0,layer_number:0,length:"0",spec:"",thickness:"0",veneer_avg:"",width:[]}]
                    }
                    item.width.forEach(arr=>{
                        arr.thickness = item.original_thickness
                        arr.length =item.original_length
                    })
                    item.sales_width.forEach(arr=>{
                        arr.thickness = item.original_thickness
                        arr.length =item.original_length
                    })
                })
                this.dialogVisibleWidth=true;
            },
            getSelectTranslateList(target){
                this.$getSelectTranslateList(target,this.params).then(res=>{
                    this.selectMapC[target]=res.data.data;
                })
            },
            batchDel(){
                if(this.selectRow.length<1){
                    this.tip("请选择数据","warning")
                }else{
                    for(let i=0;i<this.selectRow.length;i++){
                        if(!this.selectRow[i].isDelete){
                            // flag = false;
                            this.tip("选择订单中有不可删除项","warning")
                            return;
                        }else{
                            this.$confirm('是否删除?', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            let arr = new Array();
                            this.selectRow.forEach(item=>{
                                arr.push(item.id)
                            })
                            this.postFunc("/erp/translate.package.delete",{ids:arr},()=>{
                                this.tip("删除成功","success")
                                this.getList();
                            },error=>{
                                this.tip(error.data.message,"warning")
                            })
                        }).catch(()=>{});
                        }
                    }
                }
            },
            filterConfirm(){
                if(this.isGlobal){
                    this.getBillColumn()
                }else{
                    this.getList()
                }
            },
            getBillColumn(){
                if(this.isGlobal){
                    let {columnType} = this.$data;
                    this.filterA =[]
                    this.filterB =[]
                    this.postFunc("/erp/company.column.data",{scene:this.sceneIn},response=>{
                        if(columnType.indexOf(1)!=-1){
                            this.billColumn = ","+response.data.data.fields.join(",").toString()+",";
                            this.filterA = response.data.data.columns;
                            this.filtersA = response.data.data.columns;
                            this.filterB = this.filtersB
                        } 
                        if(columnType.indexOf(2)!=-1){
                            this.tiltingColumn = ","+response.data.data.fields.join(",").toString()+",";
                            this.filterB = response.data.data.columns;
                            this.filtersB = response.data.data.columns;
                            this.filterA = this.filtersA
                        }
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }else{
                    this.filter =[]
                    this.postFunc("/erp/company.column.data",{scene:'translate.package.list'},response=>{
                        this.billColumn = ","+response.data.data.fields.join(",").toString()+",";
                        this.filter = response.data.data.columns;
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }
            },
            getTableSummaries(params) {
                return this.$setSummaryFields(params, {
                    original_cube: 4,//码单立方
                    cost_amount:2,
                    purchase_amount:2,//采购金额
                });
            },
            getTableSummariesB(params) {
                return this.$setSummaryFields(params, {
                    original_cube: 4,//码单立方
                    cost_amount:2,
                    // cube_price:2,
                    purchase_amount:2,//采购金额
                });
            },
            getSelectList(target){
                this.$getSelectList(target).then(res=>{
                    this.selectMap[res.target]=JSON.parse(JSON.stringify(res.list));
                })
            },
            inDetailChangePieces(val){
                if(Number(val)||Number(val)==0){
                    for(let i=0;i<this.form_params.in.detail.length;i++){
                        if(this.form_params.in.detail[i].pieces!=val){
                            this.form_params.in.detail[i].pieces = Number(this.form_params.out.detail[0].pieces)-Number(val)
                        }
                    }
                }
            },
            inDetailChangelayer(val){
                if(!this.isShowEdit){
                    if(Number(val)||Number(val)==0){
                        for(let i=0;i<this.form_params.in.detail.length;i++){
                            if(this.form_params.in.detail[i].layer_number!=val){
                                this.form_params.in.detail[i].layer_number = Number(this.form_params.out.detail[0].layer_number)-Number(val)
                            }
                        }
                    }
                }
            },
            inDetailChangeCube(val){
                if(!this.isShowEdit){
                    if(Number(val)||Number(val)==0){
                       for(let i=0;i<this.form_params.in.detail.length;i++){
                           if(this.form_params.in.detail[i].original_cube!=val){
                               this.form_params.in.detail[i].original_cube = this.keepLimit(this.keepLimit(this.form_params.out.detail[0].original_cube)-this.keepLimit(val))
                           }
                       }
                    }
                }
            },
            outSalesmanFunc(){
                let {businessRelationForm} = this.$data;
                let params = {
                    order_id:businessRelationForm.order_id,
                    customer_id:businessRelationForm.customer_id,
                }
                this.postFunc("/erp/finance.order.salesman.select",params,res=>{
                    this.salesman = res.data.data;
                })
            },
            outSalesmanChange(){
                this.businessRelationForm.order_id = "";
                this.businessRelationForm.customer_id = "";
            },

            outCustomerFunc(){
                let {businessRelationForm} = this.$data;
                let params = {
                    order_id:businessRelationForm.order_id,
                    salesman_id:businessRelationForm.salesman_id
                }
                this.postFunc("/erp/finance.order.customer.select",params,res=>{
                    this.customer = res.data.data;
                })
            },
            outCustomerChange(e){
                this.customer.forEach(item=>{
                    if(item.id == e){
                        this.salesman = [
                            {
                                id:item.salesman_id,
                                name:item.salesman_name,
                            }
                        ]
                        this.businessRelationForm.salesman_id = item.salesman_id;
                    }
                })
            },
            outOrderSnFunc(){
                let {businessRelationForm} = this.$data;
                let params = {
                    salesman_id:businessRelationForm.salesman_id,
                    customer_id:businessRelationForm.customer_id,
                }
                this.postFunc("/erp/finance.order.select",params,res=>{
                    this.orderSn = res.data.data;
                })
            },
            outOrderSnChange(e){
                // 获取当前选中销售单 渲染 客户 销售人
                let {orderSn} = this.$data;
                if(e){
                    orderSn.forEach(item=>{
                        if(item.id == e){
                            // 渲染销售人
                            this.salesman = [
                                {
                                    id:item.salesman_id,
                                    name:item.salesman_name,
                                }
                            ]
                            this.businessRelationForm.salesman_id = item.salesman_id;
                            // 渲染客户名称
                            this.customer = [
                                {
                                    id:item.customer_id,
                                    name:item.customer_name,
                                    salesman_id:item.salesman_id,
                                    salesman_name:item.salesman_name,
                                }
                            ]
                            this.businessRelationForm.customer_id = item.customer_id;
                            this.businessRelationForm.order_id = item.id;
                        }
                    })
                }
            },
            //重置修改
            resetAndModify(){
                this.form_template_params.in.detail =JSON.parse(JSON.stringify(this.form_template_params.out.detail));
                this.form_template_params.in.detail.forEach(item => {
                    item.cube_price = item.cost_price; 
                    item.purchase_amount =this.keepPrice(this.$bc_mul(item.original_cube,item.cube_price))
                });
            },
            transferConfirm(type){
                this.$refs["saleorderA"].validate((valid) => {
                    if(valid){
                        this.$confirm('请选择成品明细录入方式', '提示', {
                            distinguishCancelAndClose: true,
                            confirmButtonText: '模版导入',
                            cancelButtonText: '直接修改',
                            type: 'warning',
                        }).then(() => {
                            let obj = new Object();
                            obj.old_inventory=[];
                            // obj.new_inventory=[];
                            this.form_params.out.detail.forEach(item=>{
                                obj.old_inventory.push(item.inventory_id)
                            })
                            this.form_params.in.detail.forEach(item=>{
                                if(item.width||item.sales_width){
                                    item.width.forEach(em=>{
                                        if(em.width.length == 0){
                                            item.width = []
                                        }
                                        if(em.width.length> 0){
                                            item.original_cube=""
                                        }
                                    })
                                    item.sales_width.forEach(em=>{
                                    if(em.width.length == 0){
                                        item.sales_width = []
                                        }
                                    })
                                }
                                // obj.new_inventory.push(item)
                            })
                            obj.remark = this.form_params.remark;
                            if(type==1){obj.status = 1; }
                            if(type==2){obj.status = 2; }
                            obj.tran_type = 0;
                            obj.fee_list = this.fee_list;
                            obj.tran_date = parseInt(this.form_params.tran_date.getTime()/1000);
                            obj.jg_type = this.form_params.jg_type;
                            obj.factory_id = this.form_params.factory_id;
                            obj.drying_cave = this.form_params.drying_cave;
                            obj.inbound_time = this.form_params.inbound_time;
                            this.postFuncLoading("/erp/translate.package.create",obj,res=>{
                                this.tip("操作成功","success");
                                this.dialogVisible=false;
                                this.getList();
                                this.edit(res.data.data.id);
                            },error=>{
                                this.tip(error.data.message,"warning")
                            })
                        }).catch(action=>{
                            if(action==='cancel'){
                                this.form_template_params = JSON.parse(JSON.stringify(this.form_params));
                                this.form_template_params.tran_date = this.form_params.tran_date;
                                this.form_template_params.in.detail =JSON.parse(JSON.stringify(this.form_params.out.detail));
                                this.form_template_params.in.detail.forEach(item => {
                                    item.cube_price = item.cost_price; 
                                    item.purchase_amount =this.keepPrice(this.$bc_mul(item.original_cube,item.cube_price))

                                });
                                this.dialogTemplateVisibles = true;
                            }
                        });
                    } else {
                        return false;
                    }
                })
            },
            //入库保存
            storeSave(type){
                this.$refs["saleorderB"].validate((valid) => {
                    if(valid){
                        let newData =   JSON.parse(JSON.stringify(this.form_template_params.in.detail));
                        let obj = new Object();
                        obj.old_inventory=[];
                        obj.new_inventory=[];
                        this.form_template_params.out.detail.forEach(item=>{
                            obj.old_inventory.push(item.inventory_id)
                        })
                        // this.form_template_params.in.detail.forEach(item=>{
                            // if(item.width||item.sales_width){
                            //     item.width.forEach(em=>{
                            //         if(em.width.length == 0){
                            //             item.width = []
                            //         }
                            //         if(em.width.length> 0){
                            //             item.original_cube=""
                            //         }
                            //     })
                            //     item.sales_width.forEach(em=>{
                            //     if(em.width.length == 0){
                            //         item.sales_width = []
                            //         }
                            //     })
                            // }
                            // obj.new_inventory.push(item)
                        // })
                        obj.new_inventory = newData;
                        obj.remark = this.form_template_params.remark;
                        if(type==1){obj.status = 1; }
                        if(type==2){obj.status = 2; }
                        obj.tran_type = 1;
                        obj.fee_list = this.fee_list;
                        obj.tran_date = parseInt(this.form_template_params.tran_date.getTime()/1000);
                        obj.jg_type = this.form_template_params.jg_type;
                        obj.factory_id = this.form_template_params.factory_id;
                        obj.drying_cave = this.form_template_params.drying_cave;
                        obj.inbound_time = this.form_template_params.inbound_time;
                        this.postFuncLoading("/erp/translate.package.create",obj,res=>{
                            this.tip("操作成功","success");
                            this.dialogTemplateVisibles=false;
                            this.dialogVisible=false;
                            this.getList();
                            this.edit(res.data.data.id);
                        },error=>{
                            this.tip(error.data.message,"warning")
                        })
                    } else {
                        return false;
                    }
                })
            },
            auditTime(){
                this.checkoutDialog  =true;
            },
            // 审核完成
            auditCompleted(){
                // this.postFuncLoading("/erp/translate.package.confirm",{id:this.editid,date:parseInt(this.time.date.getTime()/1000)},res=>{
                //     this.tip("审核完成","success");
                //     this.checkoutDialog = false;
                //     this.checkoutDialogB=false;
                //     this.dialogVisibles=false;
                //     this.getList()
                // },error=>{
                //     this.tip(error.data.message,"warning")
                // })
                let obj ={};
                obj.id = this.editid;
                obj.date = parseInt(this.time.date.getTime()/1000);
                if(this.action!=''){
                    obj.action = this.action;
                }
                this.$axios.post("/erp/translate.package.confirm",obj).then((response) => {
                    if(response.data.code == 0){
                        this.tip("审核完成","success");
                        this.checkoutDialog = false;
                        this.checkoutDialogB=false;
                        this.dialogVisibles=false;
                        this.getList()
                    }
                    if(response.data.code == 1300){
                        this.tip(response.data.message,"warning")
                    }
                    if(response.data.code == 400){
                        this.openConfirm();
                    }   
                }).catch((error) => {
                    window.console.log(error);
                })
            },
            openConfirm(){
                this.$confirm('已有销售单锁定翻包明细,继续会影响销售利润,是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.action = 'Y';
                    this.auditCompleted();
                }).catch(()=>{
                    // this.action = 'N';
                    // this.auditCompleted();
                });
            },
            //打开入库确认弹框
            openCheckout(){
                this.checkoutDialog = !this.checkoutDialog;
            },
            //打开入库确认弹框
            openCheckoutB(){
                // this.checkoutDialogB = !this.checkoutDialogB;
            },
            transferConfirmUpdate(type){
                this.$confirm('是否确认操作?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                        let obj = new Object();
                        obj.old_inventory=[];
                        // obj.new_inventory=[];
                        this.form_params.out.detail.forEach(item=>{
                            obj.old_inventory.push(item.inventory_id)
                        })
                        // this.form_params.in.detail.forEach(item=>{
                        //     item.width.forEach(em=>{
                        //         if(em.width.length == 0){
                        //             item.width = []
                        //         }
                        //         if(em.width.length > 0){ 
                        //             item.original_cube=""
                        //         }
                        //     })
                        //         item.sales_width.forEach(em=>{
                        //         if(em.width.length == 0){
                        //             item.sales_width = []
                        //         }
                        //     })
                        //     obj.new_inventory.push(item)
                        // })
                        // obj.remark = this.form_params.remark;
                        obj.id = this.editid
                        if(type==1){
                            obj.status = 1; 
                            // obj.inbound_time =parseInt(this.form_params.inbound_time.getTime()/1000);
                            // obj.warehouse_id = this.form_params.warehouse_id;
                        }
                        if(type==2){
                            obj.status = 2; 
                        }
                        obj.tran_date = parseInt(this.form_params.tran_date.getTime()/1000);
                        obj.jg_type = this.form_params.jg_type;
                        obj.factory_id = this.form_params.factory_id;
                        obj.drying_cave = this.form_params.drying_cave;
                        obj.inbound_time = this.form_params.inbound_time;
                        obj.remark = this.form_params.remark;
                        obj.fee_list = this.fee_list;
                        this.postFuncLoading("/erp/translate.package.update",obj,()=>{
                            this.tip("操作成功","success");
                            this.checkoutDialogB=false;
                            this.dialogVisibles=false;
                            this.getList()
                        },error=>{
                            this.tip(error.data.message,"warning")
                        })
                }).catch(()=>{});
            },
            transferExport(){
                this.$exportExecl("/erp/translate.package.info.export","库存翻包",{id:this.editid})
            },
            print(){
                // this.$exportExecl("/erp/translate.package.info.print","货物转库",{id:this.editid})
                // let url = "/erp/translate.package.info.print?id=" + this.editid + "&category=" + 1;
                window.open("/erp/translate.package.info.print","库存翻包",{id:this.editid});              
            },
            //跳转成品明细
            openData(){
                sessionStorage.setItem("FINISHED_PRODUCT_DETAILS_ID",this.goodsId)
                this.$root.$children[0].$children[0].addTab({
                    name: '成品明细'+this.goodsId,
                    label: '成品明细',
                    content: 'warehouseRummageDetail'
                });
                this.dialogVisibles = false;
            },
            //平摊采购单价
            flatOut(){
                this.$confirm('成品明细的采购单价将会以原料的合计成本金额平摊?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    // this.postFuncLoading('/erp/translate.split.amount',{id:this.goodsId},()=>{
                    //     this.tip("操作成功","success");
                    //     this.dialogVisibles = false;
                    //     this.edit(this.goodsId);
                    // },error=>{
                    //     this.tip(error.data.message,"warning")
                    // })
                    let obj = {};
                    obj.id = this.goodsId;
                    if(this.action!=''){
                        obj.action = this.action;
                    }
                    this.$axios.post("/erp/translate.split.amount",obj).then((response) => {
                        if(response.data.code == 0){
                            this.tip("操作成功","success");
                            this.dialogVisibles = false;
                            this.edit(this.goodsId);
                        }
                        if(response.data.code == 1300){
                            this.tip(response.data.message,"warning")
                        }
                        if(response.data.code == 400){
                            this.openConfirmB();
                        }   
                    }).catch((error) => {
                        window.console.log(error);
                    })
                })
            },
            openConfirmB(){
                this.$confirm('已有销售单锁定翻包明细,继续会影响销售利润,是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.action = 'Y';
                    let obj = {};
                    obj.id = this.goodsId;
                    if(this.action!=''){
                        obj.action = this.action;
                    }
                    this.postFuncLoading('/erp/translate.split.amount',obj,()=>{
                        this.tip("操作成功","success");
                        this.isCanEdit = true;
                        this.dialogVisibles = false;
                        this.edit(this.goodsId);
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{
                    // this.action = 'N';
                    // this.auditCompleted();
                });
            },
            openbusinessRelation(){
                this.businessRelation = true;
                this.businessRelationForm.fee_date = new Date();
            },
            delOutFee(ind,id){
                this.$confirm('是否删除?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.postFuncLoading('/erp/fee.delete',{ids:id},()=>{
                        this.tip("删除成功","success");
                        this.fee_list.forEach((item,index)=>{
                            if(index==ind){
                                this.fee_list.splice(index,1)
                            }
                        })
                    })
                }).catch(()=>{});
            },
            in_warehouseChange(e){
                this.selectMap.warehouse.forEach(item=>{
                    if(item.id==e){
                        this.in_warehouse_name = item.name;
                    }
                })
            },
            outFeeChange(e){
                this.outFeeSelect.forEach(item=>{
                    if(item.id==e){
                        this.businessRelationForm.fee_name = item.name;
                    }
                })
            },
            //获取费用名称
            outFeeSelectFunc(){
                this.postFunc("/erp/purchase.cost.type",{},res=>{
                    this.outFeeSelect=res.data.data;
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            newOutFee(){
                for(let key in this.businessRelationForm){
                    if(this.businessRelationForm[key]==""){
                        if(key=="remark"){
                            this.pl(key)
                        }else{
                            this.tip("请填写完整信息","warning")
                            return;
                        }
                    }
                }
                let time = this.businessRelationForm.fee_date;
                this.businessRelationForm.fee_date=this.formatTimeZero(this.businessRelationForm.fee_date);
                let obj = {};
                obj = this.businessRelationForm;
                obj.id = this.goodsId;
                const loading = this.$loading({
                    lock: true,//lock的修改符--默认是false
                    text: 'Loading',//显示在加载图标下方的加载文案
                    spinner: 'el-icon-loading',//自定义加载图标类名
                    background: 'rgba(0, 0, 0, 0.7)',//遮罩层颜色
                    target: document.querySelector('#table')//loadin覆盖的dom元素节点
                })
                this.$axios.post('/erp/translate.cost.addfee',obj).then((response) => {
                    loading.close();
                    if(response.data.code == 0){
                        this.tip("操作成功","success");
                        this.businessRelation = false;
                        this.fee_list.push(JSON.parse(JSON.stringify(this.businessRelationForm)))
                    }
                    if(response.data.code == 1300){
                        this.businessRelationForm.fee_date = time;
                        this.tip(response.data.message,"warning")
                    }
                    if(response.data.code == 1000){
                        this.businessRelationForm.fee_date = time;
                        this.tip(response.data.message,"warning")
                    }
                    if(response.data.code == 400){
                        this.businessRelationForm.fee_date = time;
                        this.newOutFeeB();
                    }   
                }).catch((error) => {
                    window.console.log(error);
                })
                // this.businessRelation=!this.businessRelation;
            },

            newOutFeeB(){
                this.$confirm('已有销售单锁定翻包明细,继续会影响销售利润,是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.action = 'Y';
                    let obj = {};
                    this.businessRelationForm.fee_date=this.formatTimeZero(this.businessRelationForm.fee_date);
                    obj = this.businessRelationForm;
                    obj.id = this.goodsId;
                    if(this.action!=''){
                        obj.action = this.action;
                    }
                    this.postFuncLoading('/erp/translate.cost.addfee',obj,()=>{
                        this.tip("操作成功","success");
                        this.fee_list.push(JSON.parse(JSON.stringify(this.businessRelationForm)))
                        this.businessRelation = false;
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{
                    // this.action = 'N';
                    // this.auditCompleted();
                });
            },
            handle(){
                this.form_params.in.detail=[];
                this.form_params.in.detail.push(JSON.parse(JSON.stringify(this.form_params.out.detail[0])))                    
                return true;
            },
            //总宽度返回
            widthReturn(res){
                this.salesEditDialog = true;
                this.salesEditContent = res;
            },
            widthEdit(res){
                this.form_template_params.in.detail[this.indetailType].width=res;
                this.calculation(this.indetailType);
                
                if(this.is_sales==true){
                    this.saleWidthReturn(res)
                    
                }
                this.salesEditDialog = false;
            },
            //销售宽度修改返回
            saleWidthReturn(res){
                this.form_template_params.in.detail[this.indetailType].sales_width=res;
                this.calculation(this.indetailType);
            },
            calculationTotalWidth(formNumber){
                let total = "";
                let countWidth = "";
                let layer_number = "";
                this.form_template_params.in.detail[formNumber].width.forEach((item,index)=>{
                    if(this.sameType == 1){
                        if(item.width_other!=undefined){
                            countWidth = item.width_other;
                        }
                        layer_number = item.layer_number;
                        total += !!item.width&&item.width.length>0?item.width.reduce((prev,next)=> Number(prev)+Number(next)):""
                        total += !!item.width&&item.width.length>0?",":"";
                    }else{
                        // let width_other = JSON.parse(JSON.stringify(item.width_other));
                        // if(item.layer_number){//均宽余数有数据时，总宽度=（宽度明细合计/输入宽度个数）*层数+均宽余数、
                            let layer_number = JSON.parse(JSON.stringify(item.layer_number));
                            if(item.width_other==''||item.width_other==undefined){
                                total += !!item.width&&item.width.length>0?this.keepLimit(item.width.reduce((prev,next)=>this.keepLimit( Number(prev)+Number(next)))):"";
                                total += !!item.width&&item.width.length>0?",":"";
                            }else{//均宽余数有数据时，总宽度=（宽度明细合计/输入宽度个数）*层数+均宽余数
                                if(layer_number!=''){
                                    total += !!item.width&&item.width.length>0?
                                    this.rounding(this.$bc_add(this.$bc_mul(this.$bc_div(this.keepLimit(item.width.reduce((prev,next)=>this.keepLimit( Number(prev)+Number(next)))),item.width.length),item.layer_number),item.width_other))
                                    :"";
                                    total += !!item.width&&item.width.length>0?",":"";
                                }else{
                                    total = item.width_other;
                                    total += !!item.width&&item.width.length>0?",":"";
                                }
                            }
                        // }else{
                            //     total += !!item.width&&item.width.length>0?this.keepLimit(item.width.reduce((prev,next)=>this.keepLimit( Number(prev)+Number(next)))):"";
                        //     total += !!item.width&&item.width.length>0?",":"";
                        // }
                    }
                })
                if(this.sameType == 1){
                    if(layer_number==0){
                        total = String(this.keepLimit(total.substring(0,total.length-1)));
                    }else{
                        if(countWidth){
                            total = String(this.keepLimit(total.substring(0,total.length-1)/countWidth*(layer_number?layer_number:1)));
                        }else{
                            total = String(this.keepLimit(total.substring(0,total.length-1)));
                        }
                    }
                }else{
                    total = String((total.substring(0,total.length-1)));
                }
                this.form_template_params.in.detail[formNumber].original_width_total = total;
            },
            //销售总宽度
            calculationSalesWidthTotalWidth(formNumber){
                let total = "";
                let countWidth = "";
                let layer_number = "";
                this.form_template_params.in.detail[formNumber].sales_width.forEach((item,index)=>{
                    if(item.layer_number==undefined){
                        item.layer_number=''
                    }
                    if(this.sameType == 1){
                        if(item.width_other!=undefined){
                            countWidth = item.width_other;
                        }
                        layer_number = item.layer_number;
                        total += !!item.width&&item.width.length>0?item.width.reduce((prev,next)=> Number(prev)+Number(next)):""
                        total += !!item.width&&item.width.length>0?",":"";
                    }else{
                        // let width_other = JSON.parse(JSON.stringify(item.width_other));
                        // if(item.layer_number){//均宽余数有数据时，总宽度=（宽度明细合计/输入宽度个数）*层数+均宽余数、
                            let layer_number = JSON.parse(JSON.stringify(item.layer_number));
                            if(item.width_other==''||item.width_other==undefined){
                                total += !!item.width&&item.width.length>0?this.keepLimit(item.width.reduce((prev,next)=>this.keepLimit( Number(prev)+Number(next)))):"";
                                total += !!item.width&&item.width.length>0?",":"";
                            }else{//均宽余数有数据时，总宽度=（宽度明细合计/输入宽度个数）*层数+均宽余数
                                if(layer_number!=''){
                                    total += !!item.width&&item.width.length>0?
                                    this.rounding(this.$bc_add(this.$bc_mul(this.$bc_div(this.keepLimit(item.width.reduce((prev,next)=>this.keepLimit( Number(prev)+Number(next)))),item.width.length),item.layer_number),item.width_other))
                                    :"";
                                    total += !!item.width&&item.width.length>0?",":"";
                                }else{
                                    total = item.width_other;
                                    total += !!item.width&&item.width.length>0?",":"";
                                }
                            }                      
                    }
                })
                if(this.sameType == 1){
                    if(layer_number==0){
                        total = String(this.keepLimit(total.substring(0,total.length-1)));
                    }else{
                        if(countWidth){
                            total = String(this.keepLimit(total.substring(0,total.length-1)/countWidth*(layer_number?layer_number:1)));
                        }else{
                            total = String(this.keepLimit(total.substring(0,total.length-1)));
                        }
                    }
                }else{
                    total = String((total.substring(0,total.length-1)));
                }
                this.form_template_params.in.detail[formNumber].sales_width_total = total;
            },
            calculation(formNumber){
                this.calculationTotalWidth(formNumber)
                this.calculationSalesWidthTotalWidth(formNumber)
                let keepIndex = ",";
                let removeIndex = ",";
                this.form_template_params.in.detail[formNumber].width.forEach((item,index)=>{
                    if(item.width.length>0){
                        keepIndex += index+",";
                    }else{
                        removeIndex += index+",";
                    }
                })
                this.form_template_params.in.detail[formNumber].sales_width.forEach((item,index)=>{
                    if(item.width.length>0){
                        keepIndex += index+",";
                    }else{
                        removeIndex += index+",";
                    }
                })
                let number = formNumber==1?number=0:number=1;
                let otherList = JSON.parse(JSON.stringify(this.removeOriginal));
                // let otherSalesWidthList = JSON.parse(JSON.stringify(this.removeSalesWidthOriginal));
                if(this.removeThicknessOriginal.split(",").length==1){
                    let inData = 0;
                    let inSalesWidthData = 0;
                    if(this.form_template_params.in.detail[formNumber].width.length>0){
                        inData = (this.form_template_params.in.detail[formNumber].width[0].width).reduce((prev,next)=>{
                            return Number(prev)+Number(next)
                        })
                    }
                    let cha = Number(this.removeTotalOriginal) - Number(inData)
                    if(otherList.length>0){
                        otherList[0].width = [];
                        otherList[0].width[0] = cha;
                    }
                }else{
                    this.removeOriginal.forEach((item,index)=>{
                        if(removeIndex.indexOf(","+index+",")!=-1){
                            // otherList.push(JSON.parse(JSON.stringify(item)))
                            otherList[index].width = item.width;
                        }else{
                            otherList[index].width = [];
                        }
                    })
                }
             
                this.calculationCube(formNumber);
                this.changeOtherData(formNumber,keepIndex);
                this.upodateType = 3;
            },            
            //点击总宽度
            widthClick(row,index){
                this.widthList = JSON.parse(JSON.stringify(row.width));
                this.dialogVisibleWidth=true;
                this.isCanEditTotalWidth=true;
                this.indetailType=index;
                this.isCanEditTotalWidth=!this.isCanEdit?true:false;
            },
            //点击销售总宽度
            salesWidthClick(row,index){
                this.widthList = JSON.parse(JSON.stringify(row.sales_width));
                this.saleDialogVisibleWidth=true;
                this.isSaleCanEditTotalWidth=true;
                this.indetailType=index;
                this.isSaleCanEditTotalWidth=!this.isCanEdit?true:false;
            },
            changeOtherData(formNumber,keepIndex){
                return
                let thicknessList = this.removeThicknessOriginal.split(",");
                if(thicknessList.length>1){
                    let lengthList = this.removeLengthOriginal.split(",");
                    let piecesList = this.removePiecesOriginal.split(",");
                    let thickness = "";
                    let length = "";
                    let pieces = "";
                    thicknessList.forEach((item,index)=>{
                        if(keepIndex.indexOf(","+index+",")!=-1){
                            thickness += thicknessList[index] + ",";
                            length += lengthList[index] + ",";
                            pieces += piecesList[index] + ",";
                        }
                    })
                    this.form_params.in.detail[formNumber].original_thickness = thickness.substring(0,thickness.length-1);
                    this.form_params.in.detail[formNumber].original_length = length.substring(0,length.length-1);
                    this.form_params.in.detail[formNumber].pieces = pieces.substring(0,pieces.length-1);
                }
            },
            calculationCube(formNumber){
                if(this.form_template_params.in.detail[formNumber].original_width_total){
                    let arr = this.form_template_params.in.detail[formNumber].width;
                    let newThickness = arr.map(a=>{
                        return a.thickness//厚度
                    })
                    let newLength = arr.map(a=>{
                        return a.length//长度
                    })
                    //码单立方
                    let newArr = arr.map(a=>{
                        return Number(a.cube)
                    })
                    let newCube = newArr.reduce(function(a, b){
                        if(b){
                            return a + b; 
                        }else{
                            return a
                        }
                    }, 0); 
                    //层数 
                    let layer_numberArr = arr.map(a=>{
                        return Number(a.layer_number)
                    })
                    let newlayer_number = layer_numberArr.reduce(function(a, b){
                        if(b){
                            return a + b; 
                        }else{
                            return a
                        }
                    }, 0); 
                    //片数
                    let piecesArr = arr.map(a=>{
                        return Number(a.pieces)
                    })
                    let newpieces = piecesArr.reduce(function(a, b){
                        if(b){
                            return a + b; 
                        }else{
                            return a
                        }
                    }, 0);
                    this.form_template_params.in.detail[formNumber].original_thickness = String(newThickness);//厚度
                    this.form_template_params.in.detail[formNumber].original_length = String(newLength);//长度
                    this.form_template_params.in.detail[formNumber].original_cube = this.keepLimit(newCube);//，码单立方
                    this.form_template_params.in.detail[formNumber].layer_number = newlayer_number;//层数
                    this.form_template_params.in.detail[formNumber].pieces = newpieces;//片数
                }else{
                    let cal_cube = 0;
                    let thickness = this.form_template_params.in.detail[formNumber].original_thickness.split(",");
                    let length = this.form_template_params.in.detail[formNumber].original_length.split(",");
                    let widthT = this.form_template_params.in.detail[formNumber].original_width_total.split(",");
                    widthT.forEach((item,index)=>{
                            cal_cube += (Number(thickness[index])/100)*length[index]*(Number(widthT[index])/100)//码单立方计算
                    })
                    this.form_template_params.in.detail[formNumber].original_cube = this.keepLimit(cal_cube);//，码单立方
                }
                if(this.form_template_params.in.detail[formNumber].sales_width_total){
                    let salesArr = this.form_template_params.in.detail[formNumber].sales_width;
                    let newThickness = salesArr.map(a=>{
                        return a.thickness//厚度
                    })
                    let newLength = salesArr.map(a=>{
                        return a.length//长度
                    })
                    //码单立方
                    let newArr = salesArr.map(a=>{
                        return Number(a.cube)
                    })
                    let newCube = newArr.reduce(function(a, b){
                        if(b){
                            return a + b; 
                        }else{
                            return a
                        }
                    }, 0); 
                    //层数 
                    let layer_numberArr = salesArr.map(a=>{
                        return Number(a.layer_number)
                    })
                    let newlayer_number = layer_numberArr.reduce(function(a, b){
                        if(b){
                            return a + b; 
                        }else{
                            return a
                        }
                    }, 0); 
                    //片数
                    let piecesArr = salesArr.map(a=>{
                        return Number(a.pieces)
                    })
                    let newpieces = piecesArr.reduce(function(a, b){
                        if(b){
                            return a + b; 
                        }else{
                            return a
                        }
                    }, 0);
                    this.form_template_params.in.detail[formNumber].sales_cube = this.keepLimit(newCube);//，销售立方
                }
                this.purchaseAmountCalculation();
            },
            //采购金额计算
            purchaseAmountCalculation(){
                let newData =JSON.parse(JSON.stringify( this.form_template_params.in.detail));
                newData.forEach(item => {
                    item.purchase_amount =this.keepPrice(this.$bc_mul(item.original_cube,item.cube_price))
                });
                this.form_template_params.in.detail = newData;
            },
            listDetailInAdd(){
                // let data = JSON.parse(JSON.stringify(this.form_params.in.detail[0]))
                // data.original_cube = "";
                // this.form_params.in.detail.push(data)
                this.form_params.in.detail.push({
                    // bale_no:"",brand_id:"",brand:"",breed:"",breed_id:"",grade_id:"",grade:"",original_thickness:"",original_length:"",original_width_total:"",pieces:"",original_cube:"",sales_cube:"",cube_price:"",cost:"",cost_price:"",ship_no:"",status:"",warehouse:"",warehouse_id:"",remark:"",status_text:""
                    bale_no:"",
                                breed_id:"",
                                brand_id:"",
                                grade_id:"",
                                original_thickness:"0",
                                original_length:"0",
                                original_width_total:0,
                                width:[
                                    {cube:0,layer_number:0,length:"0",spec:"",thickness:"0",veneer_avg:"",width:[]}
                                ],
                                sales_width_total:0,
                                sales_width:[
                                    {cube:0,layer_number:0,length:"0",spec:"",thickness:"0",veneer_avg:"",width:[]}
                                ],
                                pieces:"",
                                layer_number:"",
                                original_cube:"",
                                sales_cube:"",
                                sales_price:"",
                                color_id:"",
                                attribute_id:"",
                                warehouse_id:"",
                                remark:"",
                })

            },
            listDetailInDelete(index){
                this.form_params.in.detail.splice(index,1)
                if(this.form_params.in.detail.length<=0){
                    this.form_params.in.detail.push({bale_no:"",brand_id:"",brand:"",breed:"",breed_id:"",grade_id:"",grade:"",original_thickness:"",original_length:"",original_width_total:"",pieces:"",original_cube:"",sales_cube:"",cube_price:"",cost:"",cost_price:"",ship_no:"",status:"",warehouse:"",warehouse_id:"",remark:"",status_text:""})
                }
                this.transferNumber=this.form_params.in.detail.length;
            },
            listDetailDelete(index){
                this.form_params.out.detail.splice(index,1)
                if(this.form_params.out.detail.length<=0){
                    this.form_params.out.detail.push({id:"",bale_no:"",brand_id:"",brand:"",breed:"",breed_id:"",grade_id:"",grade:"",original_thickness:"",original_length:"",original_width_total:"",pieces:"",original_cube:"",sales_cube:"",cube_price:"",cost:"",cost_price:"",ship_no:"",status:"",warehouse:"",warehouse_id:"",remark:"",status_text:""})
                }
            },
            listTemplateDetailDelete(index){
                this.form_template_params.out.detail.splice(index,1)
                if(this.form_template_params.out.detail.length<=0){
                    this.form_template_params.out.detail.push({id:"",bale_no:"",brand_id:"",brand:"",breed:"",breed_id:"",grade_id:"",grade:"",original_thickness:"",original_length:"",original_width_total:"",pieces:"",original_cube:"",sales_cube:"",cube_price:"",cost:"",cost_price:"",ship_no:"",status:"",warehouse:"",warehouse_id:"",remark:"",status_text:""})
                }
            },
            listDetailTemplateInDelete(index){
                this.form_template_params.in.detail.splice(index,1)
            },
            //模版导入成品入库复制
            copyData(row){
                this.form_template_params.in.detail.push(JSON.parse(JSON.stringify(row)))
            },
            reset(){
                this.start_time="";
                this.end_time="";
                this.start_over_time="";
                this.end_over_time="";
                this.params={search:{start_time:"",end_time:"",start_over_time:"",end_over_time:"",sn:"",status:""},page:1,per_page:50}
                this.getList();
            },
            getList(flag){
                if(flag){
                    this.params.page = 1;
                }
                this.params.start_time=this.formatTimeZero(this.start_time);
                this.params.end_time=this.formatTimeZero(this.end_time);
                this.params.start_over_time=this.formatTimeZero(this.start_over_time);
                this.params.end_over_time=this.formatTimeZero(this.end_over_time);
                this.tableLoading = true;
                this.$postColumnList("/erp/translate.package.list",this.params,res=>{
                    this.totalObj=res.data.data.total;
                    this.filter = res.data.data.column;
                    this.last_page=parseInt(res.data.data.list.last_page);
                    this.$refs.pagination.flag = true;
                    this.tableLoading = false;
                    this.total=parseInt(res.data.data.list.total);
                    this.list=res.data.data.list.data;
                    this.list.forEach((item,index)=>{
                        this.list[index].out_time = this.formatTime(item.out_time+"000")
                        if(item.tran_date==0){
                            this.list[index].tran_date = ''
                        }else{
                            this.list[index].tran_date = this.formatTime(item.tran_date+"000")
                        }
                        if(item.over_time==0){
                            this.list[index].over_time = ''
                        }else{
                            this.list[index].over_time = this.formatTime(item.over_time+"000")
                        }
                        if(item.create_time==0){
                            this.list[index].create_time = ''
                        }else{
                            this.list[index].create_time = this.formatTime(item.create_time+"000")
                        }
                        if( this.list[index].power_operation_list.isEdit==1){
                            item.isEdit=true;
                        }
                        if( this.list[index].power_operation_list.isDelete==1){
                            item.isDelete=true;
                        }
                        if(item.inbound_time==0){
                             this.list[index].inbound_time = ''
                        }
                        // if(item.finish_days==0){
                        //      this.list[index].finish_days = ''
                        // }else{
                            this.list[index].finish_days = this.list[index].finish_days+'天'
                        // }
                    })
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            excelExport(){
                this.$exportExecl("/erp/translate.package.export","翻包加工",this.params)
            },
            del(id){
                this.$confirm('是否删除?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
                    // let id = new Array();
                    let arr = [id]
                    this.postFunc("/erp/translate.package.delete",{ids:arr},()=>{
                        this.tip("删除成功","success")
                        this.getList();
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            deleteUpdate(){
                this.$confirm('是否删除?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
                    let arr = [this.goodsId]
                    this.postFunc("/erp/translate.package.delete",{ids:arr},()=>{
                        this.tip("删除成功","success")
                        this.dialogVisibles=false;
                        this.getList();
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            edit(obj){
                this.editid = obj;
                this.isCanEdit = true
                this.Edits = true
                this.dels = true;
                this.postFunc("/erp/translate.package.info",{id:obj},res=>{
                    this.form_params.out.detail=res.data.data.old_inventory;
                    this.form_params.in.detail=res.data.data.new_inventory;
                    this.fee_list = res.data.data.fee_list;
                    this.inventory_sum = [res.data.data.inventory_sum];
                    this.form_params.drying_cave = res.data.data.drying_cave;
                    this.form_params.order_sn = res.data.data.order_sn;
                    this.form_params.jg_type = res.data.data.jg_type;
                    this.form_params.factory_id = res.data.data.factory_id==0?'':res.data.data.factory_id;
                    this.form_params.inbound_time = res.data.data.expected_time;
                    this.isCanEdit = true
                    this.dialogVisibles=true;
                    this.in_warehouse_id = res.data.data.in_warehouse_id;
                    this.warehouse_local = res.data.data.warehouse_local;
                    this.status = res.data.data.status;
                    this.bottom.creator_name = res.data.data.creator_name;
                    this.bottom.tran_date = this.formatTime(res.data.data.tran_date+"000");
                    this.bottom.transfer_name = res.data.data.transfer_name;
                    this.bottom.profit_amount = res.data.data.profit_amount;
                    // this.bottom.inbound_time = this.formatTime(res.data.data.inbound_time+"000");
                    // if(res.data.data.inbound_time!=0){
                    //     this.bottom.inbound_time = this.formatTime(res.data.data.inbound_time+"000")
                    // }else{
                    //     this.bottom.inbound_time = "";
                    // }
                    // this.Edit = res.data.data.power_operation_list.isEdit;
                    this.goodsId = res.data.data.id;
                    this.form_params.remark=res.data.data.remark;
                    for(let ke in this.form_params.in.detail){
                        this.form_params.in.detail[ke].in_warehouse = res.data.data.in_warehouse;
                    }
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            //选择库存信息
            dialogVisibleStockOpen(type){
                this.openStockType = type;
                this.dialogVisibleStock = !this.dialogVisibleStock;
            },
            selectData(row){
                this.listDetailSet(row)
            },
            selectAndOut(row){
                this.listDetailSet(row)
                this.dialogVisibleStock = !this.dialogVisibleStock;
            },
            listDetailSet(row){
                let rows=JSON.parse(JSON.stringify(row));
                rows.forEach(item=>{
                    // item.in_warehouse = item.in_warehouse;
                    item.color_id = item.color_id == 0 ? '' : item.color_id
                    item.attribute_id = item.attribute_id == 0 ? '' : item.attribute_id
                })
                if(rows.length<=0){
                    return;
                }
                if(this.openStockType==1){
                    if(this.form_params.out.detail.length==1){
                        if(this.form_params.out.detail[0].id==""){
                            this.form_params.out.detail=rows;
                            // return;
                        }
                    }
                    this.form_params.out.detail=this.form_params.out.detail.concat(rows)
                    let result = [];
                    let obj = {};
                    let data=JSON.parse(JSON.stringify(this.form_params.out.detail))
                    for(var i =0; i<data.length; i++){
                        if(!obj[data[i].id]){
                            result.push(data[i]);
                            obj[data[i].id] = true;
                        }
                    }
                    this.form_params.out.detail=result;
                    this.transferType="";
                }else if(this.openStockType==2){
                    if(this.form_template_params.out.detail.length==1){
                        if(this.form_template_params.out.detail[0].id==""){
                            this.form_template_params.out.detail=rows;
                            // return;
                        }
                    }
                    this.form_template_params.out.detail=this.form_template_params.out.detail.concat(rows)
                    let result = [];
                    let obj = {};
                    let data=JSON.parse(JSON.stringify(this.form_template_params.out.detail))
                    for(var i =0; i<data.length; i++){
                        if(!obj[data[i].id]){
                            result.push(data[i]);
                            obj[data[i].id] = true;
                        }
                    }
                    this.form_template_params.out.detail=result;
                    this.transferType="";
                }
            },
            getPage(obj){
                this.params.page=obj.currentpage;
				this.params.per_page=obj.pagesize;
            },
            rowClick(obj){
                if(obj.row.power_operation_list.isEdit==1){
                    this.Edits=true
                }
                else if(obj.row.power_operation_list.isEdit==0){
                    this.Edits=false
                }
                this.postFunc("/erp/translate.package.info",{id:obj.id},res=>{
                    this.in_warehouse_id = res.data.data.in_warehouse_id;
                    this.warehouse_local = res.data.data.warehouse_local;
                    this.status = res.data.data.status;
                    this.bottom.creator_name = res.data.data.creator_name;
                    this.inventory_sum = [res.data.data.inventory_sum];
                    this.bottom.tran_date = this.formatTime(res.data.data.tran_date+"000");
                    this.bottom.transfer_name = res.data.data.transfer_name;
                    this.bottom.profit_amount = res.data.data.profit_amount;
                    // this.bottom.inbound_time = this.formatTime(res.data.data.inbound_time+"000");
                    // if(res.data.data.inbound_time!=0){
                    //     this.bottom.inbound_time = this.formatTime(res.data.data.inbound_time+"000")
                    // }else{
                    //     this.bottom.inbound_time = "";
                    // }
                    this.isCanEdit = res.data.data.status==1?false:true;
                    this.form_params.out.detail=res.data.data.old_inventory;
                    this.form_params.in.detail=res.data.data.new_inventory;
                    this.form_params.drying_cave = res.data.data.drying_cave;
                    this.form_params.order_sn = res.data.data.order_sn;
                    this.form_params.jg_type = res.data.data.jg_type;
                    this.form_params.factory_id = res.data.data.factory_id==0?'':res.data.data.factory_id;
                    this.form_params.inbound_time = res.data.data.expected_time;
                    this.dialogVisibles=true;
                    this.Edit = obj.row.isEdit;
                    this.dels = obj.row.isDelete;
                    this.goodsId = res.data.data.id;
                    this.editid = obj.row.id;
                    if(this.status==1){
                        this.status = '已完成'
                    }else{
                        this.status = '待转库'
                    }
                    for(let ke in this.form_params.in.detail){
                        this.form_params.in.detail[ke].in_warehouse = res.data.data.in_warehouse;
                    }
                    this.fee_list = res.data.data.fee_list;
                    this.form_params.remark=res.data.data.remark;
                },()=>{})
            },
            selectionDetailChange(row){
                this.selectionDetailRow=row;
            },
            getRow(row){
                this.selectRow=row;
            },
            toggleSelection(row) {
                this.$refs.outBoundDetailTable.toggleRowSelection(row);
            },
            remarkBlur(){
                console.log(this.form_params.remark)
                let obj = new Object();      
                obj.id = this.editid;
                obj.remark = this.form_params.remark;
                this.postFuncLoading("/erp/translate.package.update.remark",obj,()=>{
                    this.tip("备注成功","success");
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            openimport(){
                this.active = this.boardAmericaType?1: this.boardZelkovaType?2:this.nationalStandardType?5:this.categoryRawType?4:this.nationalStandardType?5:"";
                this.downloadName=this.boardAmericaType?"北美材码单模板":this.boardZelkovaType?"榉木码单模板":this.boardAfricaType?"非洲材码单模板":this.nationalStandardType?"国标/非洲材码单模板":"";
                this.downloadUCode=this.boardAmericaType?"tp_america_stock":this.boardZelkovaType?"tp_america_stock":this.boardAfricaType?"tp_africa_stock":this.nationalStandardType?"tp_africa_stock":"";
                this.downloadUUrl=this.boardAmericaType?"/erp/import.qc.america":this.boardZelkovaType?"/erp/import.qc.zelkova":this.boardAfricaType?"/erp/import.qc.africa":this.nationalStandardType?"/erp/import.qc.ds":"";
                this.importDialogVisible=true;
            },
            handleSuccess(res) {
                this.file_url = res.data.base_url;
				this.$refs.upload_path.clearFiles();
                this.tip('文件上传成功', 'success');
                //this.importFile();
            },
            beforeUpload(file) {
                this.file = file;
                return this.getOss();
            },
            importFile(){
                this.postFunc('/erp/translate.package.import',{file:this.file_url,code:this.downloadUCode},response=>{
                    if (response.data.code == 0) {
                        this.tip("上传成功","success");
                        let newArr = this.form_params.in.detail.concat(response.data.data);
                        newArr.forEach((item,index)=>{
                            if(item.bale_no == '' && item.breed_id == '' && item.grade_id == ''){
                                newArr.splice(index,1);
                            }
                        })
                        this.form_params.in.detail = newArr;
                        this.importDialogVisible=false;
                    }
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            downTemplete(){
                this.exportTranslateFile(this.downloadUCode,response=>{
                    const content = response.data;
                    const blob = new Blob([content], {type: response.headers['content-type']});
                    const fileName = this.downloadName+this.getDownloadTempleteTime(new Date())+'.xlsx';
                    if ('download' in document.createElement('a')) { // 非IE下载
                        const elink = document.createElement('a');
                        elink.download = fileName;
                        elink.style.display = 'none';
                        elink.href = URL.createObjectURL(blob);
                        document.body.appendChild(elink);
                        elink.click();
                        URL.revokeObjectURL(elink.href); // 释放URL 对象
                        document.body.removeChild(elink);
                    } else { // IE10+下载
                        navigator.msSaveBlob(blob, fileName);
                    }
                })
            },
            getOss(){
                let self = this;
                return new Promise((resolve, reject) =>{
                    window.axios.post(window.oss_url+"/tool/v1/oss.policy.get",{
                        operate_code : "shop-excel"
                    }).then((response) => {
                        if(response.data.code == 0){
                            self.oss = response.data.data;
                            this.upload_data = {
                                name: self.file.name,
                                key : self.oss.dir + "${filename}",
                                policy : self.oss.policy,
                                OSSAccessKeyId : self.oss.accessid,
                                success_action_status : "200",
                                callback : self.oss.callback,
                                signature : self.oss.signature,
                                'Cache-Control' : self.oss.cache_control,
                            }
                            resolve();
                        }
                    }).catch(()=>{
                        reject();
                    })
                })
            }
        },
        components:{
            tabletem,
            pagination
        },
        watch:{
            "params.page":function(){
                this.getList();
            },
            "params.per_page":function(){
                this.getList();
            },
           "active":function(val){
                if(val==1){
                    this.downloadName="北美材码单模板";
                    this.downloadUCode="tp_america_stock";
                    this.downloadUUrl="/erp/import.qc.america";
                }else if(val==2){
                    this.downloadName="榉木码单模板";
                    this.downloadUCode="tp_america_stock";
                    this.downloadUUrl="/erp/import.qc.zelkova";
                }else if(val==3){
                    this.downloadName="非洲材码单模板";
                    this.downloadUCode="tp_africa_stock";
                    this.downloadUUrl="/erp/import.qc.africa";
                }else if(val==4){
                    this.downloadName="原木码单模板";
                    this.downloadUCode="qc_wood_stock";
                    this.downloadUUrl="/erp/import.qc.wood";
                }else if(val==5){
                    this.downloadName="国标/非洲材码单模板";
                    this.downloadUCode="tp_africa_stock";
                    this.downloadUUrl="/erp/import.qc.ds";
                }
            },
            "dialogVisible":function(val){
                if(!val){
                    this.$refs["saleorderA"].resetFields();
                    //this.form_params=this.resetJson(this.form_params)
                    this.form_params.out.detail=[];
                    this.form_params.in.detail=[];
                    this.form_params.remark="";
                    this.fee_list = [];
                    this.status = '';
                    this.sure_params ={in_warehouse:'',warehouse_local:'',inbound_time:new Date()}
                    let obj_out = {id:"",bale_no:"",brand_id:"",brand:"",breed:"",breed_id:"",grade_id:"",grade:"",original_thickness:"",original_length:"",original_width_total:"",pieces:"",original_cube:"",sales_cube:"",cube_price:"",cost:"",cost_price:"",ship_no:"",status:"",warehouse:"",warehouse_id:"",remark:"",status_text:"",}
                    let obj_in =  {
                                bale_no:"",
                                breed_id:"",
                                brand_id:"",
                                grade_id:"",
                                original_thickness:"0",
                                original_length:"0",
                                original_width_total:0,
                                width:[
                                    {cube:0,layer_number:0,length:"0",spec:"",thickness:"0",veneer_avg:"",width:[]}
                                ],
                                sales_width_total:0,
                                sales_width:[
                                    {cube:0,layer_number:0,length:"0",spec:"",thickness:"0",veneer_avg:"",width:[]}
                                ],
                                pieces:"",
                                layer_number:"",
                                original_cube:"",
                                sales_cube:"",
                                sales_price:"",
                                color_id:"",
                                attribute_id:"",
                                warehouse_id:"",
                                remark:"",
                            }
                    this.form_params.out.detail.push(JSON.parse(JSON.stringify(obj_out)))
                    this.form_params.in.detail.push(JSON.parse(JSON.stringify(obj_in)))
                    this.form_params.inbound_time ='';
                    this.form_params.warehouse_id = '';
                    this.form_params.tran_date = new Date();
                    this.form_params.jg_type = '';
                    this.form_params.drying_cave ='';
                    this.form_params.factory_id = '';
                    this.isCanEdit=false;
                }
            },
            "dialogVisibles":function(val){
                if(!val){
                    //this.form_params=this.resetJson(this.form_params)
                    this.form_params.out.detail=[];
                    this.form_params.in.detail=[];
                    this.form_params.remark="";
                    this.fee_list = [];
                    this.status ='';
                    this.sure_params ={in_warehouse:'',warehouse_local:'',inbound_time:new Date()}
                    let obj_out = {id:"",bale_no:"",brand_id:"",brand:"",breed:"",breed_id:"",grade_id:"",grade:"",original_thickness:"",original_length:"",original_width_total:"",pieces:"",original_cube:"",sales_cube:"",cube_price:"",cost:"",cost_price:"",ship_no:"",status:"",warehouse:"",warehouse_id:"",remark:"",status_text:"",}
                    let obj_in =   {
                                bale_no:"",
                                breed_id:"",
                                brand_id:"",
                                grade_id:"",
                                original_thickness:"0",
                                original_length:"0",
                                original_width_total:0,
                                width:[
                                    {cube:0,layer_number:0,length:"0",spec:"",thickness:"0",veneer_avg:"",width:[]}
                                ],
                                sales_width_total:0,
                                sales_width:[
                                    {cube:0,layer_number:0,length:"0",spec:"",thickness:"0",veneer_avg:"",width:[]}
                                ],
                                pieces:"",
                                layer_number:"",
                                original_cube:"",
                                sales_cube:"",
                                sales_price:"",
                                color_id:"",
                                attribute_id:"",
                                warehouse_id:"",
                                remark:"",
                            }
                    this.form_params.out.detail.push(JSON.parse(JSON.stringify(obj_out)))
                    this.form_params.in.detail.push(JSON.parse(JSON.stringify(obj_in)))
                    this.form_params.warehouse_id = '';
                    this.form_params.tran_date = new Date();
                    this.form_params.jg_type = '';
                    this.form_params.drying_cave ='';
                    this.form_params.factory_id = '';
                    this.isCanEdit=false;
                    this.action = '';
                }
            },
            // "form_template_params.in.detail":{
            //     immediate: true,
            //     deep: true,
            //     handler: function () {
            //         this.form_template_params.in.detail.forEach(item => {
            //             item.purchase_amount =this.keepPrice(this.$bc_mul(item.original_cube,item.cube_price))
            //         });
            //     }
            // },
            // "dialogTemplateVisibles":function(val){
            //     if(!val){
            //         //this.form_params=this.resetJson(this.form_params)
            //         this.form_template_params.out.detail=[];
            //         this.form_template_params.in.detail=[];
            //         this.form_template_params.remark="";
            //         this.fee_list = [];
            //         this.status ='';
            //         this.sure_params ={in_warehouse:'',warehouse_local:'',inbound_time:new Date()}
            //         let obj_out = {id:"",bale_no:"",brand_id:"",brand:"",breed:"",breed_id:"",grade_id:"",grade:"",original_thickness:"",original_length:"",original_width_total:"",pieces:"",original_cube:"",sales_cube:"",cube_price:"",cost:"",cost_price:"",ship_no:"",status:"",warehouse:"",warehouse_id:"",remark:"",status_text:"",}
            //         let obj_in =   {
            //                     bale_no:"",
            //                     breed_id:"",
            //                     brand_id:"",
            //                     grade_id:"",
            //                     original_thickness:"0",
            //                     original_length:"0",
            //                     original_width_total:0,
            //                     width:[
            //                         {cube:0,layer_number:0,length:"0",spec:"",thickness:"0",veneer_avg:"",width:[]}
            //                     ],
            //                     sales_width_total:0,
            //                     sales_width:[
            //                         {cube:0,layer_number:0,length:"0",spec:"",thickness:"0",veneer_avg:"",width:[]}
            //                     ],
            //                     pieces:"",
            //                     layer_number:"",
            //                     original_cube:"",
            //                     sales_cube:"",
            //                     sales_price:"",
            //                     color_id:"",
            //                     attribute_id:"",
            //                     warehouse_id:"",
            //                     remark:"",
            //                 }
            //         this.form_template_params.out.detail.push(JSON.parse(JSON.stringify(obj_out)))
            //         this.form_template_params.in.detail.push(JSON.parse(JSON.stringify(obj_in)))
            //         this.form_template_params.warehouse_id = '';
            //         this.form_template_params.tran_date = new Date();
            //         this.form_template_params.jg_type = '';
            //         this.form_template_params.drying_cave ='';
            //         this.form_template_params.factory_id = '';
            //         this.isCanEdit=false;
            //         this.action = '';
            //     }
            // },
            "dialogVisibleStock":function(val){
                if(!val){
                    this.$refs.selectStock.resetSelect();
                }
            },
            "centerDialogVisible":function(val){
                if(!val){
                    this.refuse=this.resetJson(this.refuse)
                }
            },
            'businessRelation':function(val){
                if(!val){
                    this.businessRelationForm=this.$cloneJson(initBusinessRelationForm)
                }
            },
        }
    }
</script>
<style scoped lang="scss">
    .outAndInTitle{padding:10px 0;padding-right: 20px;padding-top: 5px;font-weight: 600;color: #333;}
    .within{border-left: 4px solid #b21111;padding-left: 6px;}
    // dialog START
    .bottom_flex{ display: flex; padding-right: 12px; padding-bottom: 8px; }
    .editPayBox{
        .editPay{width:50%;float: left;height:100px;box-sizing:border-box;padding:10px;}
        .editName{font-size: 12px;color:#777;}
        .editPay:nth-child(2n){border-left:1px solid #ccc;}
    }
    .editPersonBox{
        .editPerson{width:33%;float: left;font-size: 12px;color:#777;box-sizing: border-box;padding:5px 0;}
    }
    .editBtnList{padding-top:10px;
        .editTax{float: left;}
        .editTaxname{float: left;font-size: 12px;color:#777;line-height: 25px;margin-right:5px;}
        .editTaxinput{float: left;width:100px;}
        .editBtn{float: right;}
    }
    .eldialogBack .remarkBox{width:1090px;box-sizing: border-box;}
    .transferType{padding:10px 0;}
    // 翻包录入
    .outAndInHander{position: relative;display: flex;}
    .transferNumber{display: inline-block;}
    .transferNumberInput{width:150px;height: 33px;line-height: 33px;font-size: 12px;border-radius: 3px;border:1px solid #ccc;outline: none;padding:0 10px;}
    .bottom{padding-right: 20px;}
    // dialog ENDout
    .tab_box{
        display: flex; align-items: center; border-bottom: 2px solid #EEEEEE; padding-bottom: 11px;
        & > div{
            width: 150px; text-align: center; padding: 8px 0; border:1px solid #707070; border-radius:3px; cursor: pointer; font-size: 14px;
            & + div{ margin-left: 30px; }
            &.active{ background: #B21111; color: #fff; border:1px solid #B21111; }
        }
    }
    .contractLabel:hover{cursor: pointer;color: #b21111;}
    .contractLabel:hover .labelTip{display: block;}
    .labelTip{display: none;
    position: absolute;font-weight: 600;top:-65px;left:-50px;z-index:1;width:320px;
    text-align: left;border-radius: 4px;padding:10px;box-sizing: border-box;
    box-shadow: 1px 1px 5px #ccc;padding-left:30px;z-index: 100;background-color: #000;opacity: 0.8;
    color: aliceblue;}
</style>
ß